function TabItemUI($tab, $content) {
  this.$tab = $tab;
  this.$content = $content;
  this.$tab.data("tabitem", this);
  this.hide_on_reclick = true;
  TabItemUI.items.push(this);
}

TabItemUI.hide = function (el) {
  // Hide cursor
  $(".tab-item .click-hint").show();
  $("#sidebar-tabitems-content").hide();

  for (i in TabItemUI.items) {
    if (TabItemUI.items[i].$content) {
      TabItemUI.items[i].$content.hide();
    }
  }

  $("#sidebar-navigation").show();
  $(".tab-item").closest("li").removeClass("selected");
  $(".sidebar").removeClass("parameters");
  window.location.replace($.param.fragment(window.location.href, "tab="));
  TabItemUI.current = null;
};

TabItemUI.items = new Array();
TabItemUI.loading = function () {
  $("#sidebar-navigation").hide();
  $("#sidebar-loading").show();
};

TabItemUI.hide_loading = function () {
  $("#sidebar-loading").hide();
};

TabItemUI.from_el = function ($el) {
  return $el.closest(".tab-item").data("tabitem");
};

TabItemUI.prototype = {
  click: function (_function) {
    if (_function) {
      this.click_action = _function;
    } else {
      if (TabItemUI.current && TabItemUI.current == this) {
        if (this.hide_on_reclick) {
          TabItemUI.hide();
        }
      } else {
        this.show();
        var tabId = this.$tab.data("tabid");

        window.location.replace(
          $.param.fragment(window.location.href, "tab=" + tabId)
        );
        $.Topic("ui-tab").publish({ action: "select", tabId: tabId });
        TabItemUI.current = this;
      }

      return false;
    }
  },

  update_content: function ($content) {
    this.$content = $content;

    return this;
  },

  show: function () {
    this.show_cursor();
    this.show_sidebar();

    if (this.click_action) {
      this.click_action();
    }

    if (typeof mainUI != "undefined") {
      mainUI.toolbar_fit();
    }
  },

  show_sidebar: function () {
    for (i in TabItemUI.items) {
      if (TabItemUI.items[i].$content) {
        TabItemUI.items[i].$content.hide();
      }
    }

    $("#sidebar-tabitems-content").show();

    if (this.$content) {
      this.$content.show();
    }

    $("#sidebar-navigation").hide();
    $(".sidebar").addClass("parameters");

    // This.toolbar_fit();
  },

  show_cursor: function (el) {
    $(".tab-item").closest("li").removeClass("selected");
    $(".tab-item .click-hint").show();
    this.$tab.closest("li").addClass("selected");
    $(".click-hint", this.$tab).hide();
  },
};

function MainUI(design) {
  this.design = design;
  this.bbox_need_refresh = false;
  this.embedded = false;
}

MainUI.prototype = {
  ready: function () {
    var _this = this;

    $("#close-toolbar")
      .on("hover", function () {
        $(this).toggleClass("ui-state-hover");
      })
      .on("click", function () {
        TabItemUI.hide();
      });

    $("#save-model a").on("click", function () {
      return _this.save_model($(this));
    });

    $(".Button-save").on("click", function () {
      return _this.save_model($(this));
    });

    $("#content-right").on("click", ".tab-item", function () {
      return TabItemUI.from_el($(this)).click();
    });

    // Two handlers instead of hover to prevent incorrect behaviour on reload with mouse on tab
    $("#content-right").on("mouseenter", ".tab-item", function () {
      if (
        !(
          _this.design.is_configuration_mode &&
          _this.design.is_configuration_preview_mode
        )
      ) {
        $(".op-delete-short", this).show();
      }
    });

    $("#content-right").on("mouseleave", ".tab-item", function () {
      if (
        !(
          _this.design.is_configuration_mode &&
          _this.design.is_configuration_preview_mode
        )
      ) {
        $(".op-delete-short", this).hide();
      }
    });

    $("#content-right").on("click", ".op-delete-short", function () {
      var $parent = $(this).parent();

      _this.retrieve_operations().then(function () {
        log("remove");
        var op_id = $parent.data("opid").substr(1);

        log(op_id);
        var operation = _this.design.operations[op_id];

        log(operation);
        $.when(operation.remove()).then(function () {
          $parent.parent().remove();
          TabItemUI.hide();
          _this.design.reload_operations();
        });
      });

      return false;
    });

    $("#content-right .tab-item").each(function (idx, el) {
      var ui = new TabItemUI($(el));

      if ($(el).attr("id") == "description-button") {
        ui.$content = $("#sidebar-description");
      } else if ($(el).attr("id") == "solidity-button") {
        ui.$content = $("#solidity-check");
        ui.click(function () {
          viewerUI.toggle_solidity_check(true);
        });
      } else if ($(el).attr("id") == "series-button") {
        ui.$content = $("#series");
        ui.click(function () {
          viewerUI.toggle_series(true);
        });
      } else if ($(el).attr("id") == "create-button") {
        ui.$content = $("#create-wizard");
        ui.click(function () {
          wizardUI.show_start();
        });
      } else if ($(el).attr("id") == "configure-button") {
        ui.$content = $("#configure-options");
      } else if ($(el).hasClass("tab-with-op")) {
        // Operation
        var f = function () {
          TabItemUI.loading();

          // If the deferred is already resolved, loading will be shown/hidden
          // immediately, otherwise, loading is shown while deferred
          // is not complete
          _this.retrieve_operations().then(function () {
            TabItemUI.hide_loading();
            TabItemUI.from_el($(el)).show();

            if (ui.click_action === f) {
              ui.click($.noop); // Prevent infinite recursion
            }
          });
        };

        ui.click(f);
      }
    });

    $.Topic("viewer-click").subscribe(function (data) {
      _this.handle_viewer_click(data);
    });

    $.Topic("operation-added").subscribe(function (data) {
      var $tab_item = $("#tab-item-template").clone().attr("id", "");

      $tab_item
        .find(".tab-with-op")
        .addClass("tab-item")
        .attr({
          "data-opseq": data.seq,
          "data-opid": "X" + data.id, // Prevent conversion to Number
          "data-tabid": "operation" + data.seq,
        });
      $tab_item.find(".operation-content").html(data["short"]);

      $tab_item.insertBefore($("#material-button").closest("li"));

      $tab_item.show("pulsate", { times: 4 }, 500);
      var $op = $("<div></div>", { class: "tabitem-content-operation" }).html(
        data["long"]
      );

      // Hide/show locks
      if (
        _this.design.is_configuration_mode &&
        !_this.design.is_configuration_preview_mode
      ) {
        $(".configuration-state-inactive", $op)
          .removeClass("configuration-state-inactive")
          .addClass("configuration-state-active");
        $(".if-configuration-state-active", $op).show();
        $(".if-configuration-state-inactive", $op).hide();
      } else {
        $(".configuration-state-active", $op)
          .removeClass("configuration-state-active")
          .addClass("configuration-state-inactive");
        $(".if-configuration-state-inactive", $op).show();
        $(".if-configuration-state-active", $op).hide();
      }

      $op.hide();
      $("#sidebar-tabitems-content").append($op);

      var tab = new TabItemUI($(".tab-item", $tab_item), $op);

      tab.click(function () {
        SculpteoOperationUI.from_el(
          this.$content,
          _this.design,
          _this.design.operations[data.id],
          { small: $(".ShortOperation", this.$tab) }
        ).show();
        viewerUI.toggle_display_grid(false);
      });

      _this.toolbar_fit();
    });

    // Need to find a new way to make this right panel grow gently
    $("#sidebar-tabitems-content").on("click", function () {
      _this.toolbar_fit();
    });

    $.Topic("material-selected").subscribe(function () {
      if (
        !$("#order-details-box").is(":visible") &&
        $(".sidebar").is(":visible")
      ) {
        $("#save-details-box").hide();
        $(
          "#order-details-box, #size-button, #solidity-button, #series-button, #delivery-display-box"
        ).show();
      }

      if (
        _this.design.material &&
        (!$(".finish-ifmaterial:selected").data("ifmaterial") ||
          $.inArray(
            _this.design.material.slug,
            $(".finish-ifmaterial:selected").data("ifmaterial").split(" ")
          ) == -1)
      ) {
        _this.design.order.finish = "";
        $("#cart-form [name=finish]").val("");
      }
    });

    $.Topic("operation-reloaded").subscribe(function (operations) {
      _this.load_operation(operations, true);
    });

    var selected_tab = null;

    var tab = $.deparam.fragment().tab;

    if (tab) {
      this.selected_tab = tab;
    }

    if (this.selected_tab) {
      $("[data-tabid=" + this.selected_tab + "]").click();
    }

    $.Topic("operation-fetched").subscribe(function () {
      $("#save-model").show();
      $("[data-x-sculpteo-action=export]").each(function (i, el) {
        var href = $(el).attr("href");

        href = $.param.querystring(href, { uuid: _this.design.model_uuid });
        $(el).attr("href", href);
      });

      if (
        !$("#order-details-box").is(":visible") &&
        $(".sidebar").is(":visible")
      ) {
        $("#save-details-box").show();
      }
    });

    $.Topic("operation-updated").subscribe(function (data) {
      if (data && data.update_geometry) {
        _this.bbox_need_refresh = true;
      }
    });

    $.Topic("operation-moved").subscribe(function (op_id_list) {
      // Update sequence order
      $("#content-right .tab-item.tab-with-op").each(function (index, el) {
        var id = $(el).data("opid");

        if (!id) {
          return;
        }

        id = id.substr(1);

        seq = 1 + $.inArray(id, op_id_list);

        if (!seq) {
          return;
        }

        log("update op " + id + " seq " + $(el).data("opseq") + " -> " + seq);
        $(el).data("opseq", seq);
      });
    });

    // Draggable operations
    var old_list = [];
    var liSortableSelector =
      "li:not(:has(#create-button, #material-button, #size-button, #solidity-button, #series-button))";

    $(".sortable")
      .sortable({
        axis: "y",
        delay: 300,
        tolerance: "pointer",
        helper: "clone",
        items: liSortableSelector,
        start: function (event, ui) {
          old_list.length = 0;
          $("#content-right .tab-item.tab-with-op").each(function (index, el) {
            var seq = $(el).data("opseq");

            old_list.push(seq);
          });

          log("started");
          log(old_list);
        },

        update: function (event, ui) {
          // Re-order list
          var list = [];

          $("#content-right .tab-item.tab-with-op").each(function (index, el) {
            var seq = $(el).data("opseq");

            list.push(seq);
          });

          var same = true;

          if (old_list.length != list.length) {
            same = false;
          } else {
            for (k = 0; k < list.length; k++) {
              if (old_list[k] != list[k]) {
                same = false;
                break;
              }
            }
          }

          old_list = list;

          if (!same) {
            _this.retrieve_operations().then(function () {
              var id_list = [];

              $("#content-right .tab-item.tab-with-op").each(function (
                index,
                el
              ) {
                var id = $(el).data("opid");

                if (!id) {
                  return;
                }

                id_list.push(id.substr(1));
              });

              _this.design.move_operation(id_list);
            });
          }
        },
      })
      .find(liSortableSelector)
      .find("div")
      .css({ cursor: "move" });
    $(
      "#create-button, #material-button, #size-button, #solidity-button, #series-button"
    ).css({ cursor: "pointer" });
  },

  toolbar_fit: function () {
    var sidebar_height = parseInt($("#sidebar-tabitems-content").height());
    var design_div_height = parseInt($("#designs_div").css("min-height"));

    if (sidebar_height > design_div_height - 50) {
      // Grow design div a little
      $("#designs_div").css("min-height", sidebar_height + 100);
    }
  },

  handle_viewer_click: function (pos) {
    if (typeof TabItemUI != "undefined" && TabItemUI.current) {
      var operation_ui = SculpteoOperationUI.from_el(
        TabItemUI.current.$content
      );

      if (operation_ui) {
        operation_ui.viewer_click(pos);
      }
    }
  },

  save_and_dispatch: function (el, fn, extras) {
    var _this = this;

    $(el).addClass("disabled");
    $.when(_this.design.fetch_operation())
      .pipe(function () {
        var d = { finish: 1, thumbnail: 0 };

        if (typeof extras != "undefined") {
          $.extend(d, extras);
        }

        return _this.design.save_operations(d);
      })
      .then(function (data) {
        fn(data.uuid, _this.design.order.quantity);
      });
  },

  post_to_top: function (url, params) {
    var form = document.createElement("form");

    form.setAttribute("method", "post");
    form.setAttribute("target", "_top");
    form.setAttribute("action", url);

    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var input = document.createElement("input");

        input.setAttribute("type", "hidden");
        input.setAttribute("name", key);
        input.setAttribute("value", params[key]);
        form.appendChild(input);
      }
    }

    document.body.appendChild(form);
    form.submit();
  },

  default_save_action: function () {
    $.alerts.horizontalOffset = 90;
    var _this = this;

    jPrompt(
      gettext("Update name if you want to"),
      _this.design.name,
      gettext("Update design name"),
      function (result) {
        if (result) {
          $form = $("#save-model [name=save-form]");
          $("[name=uuid]", $form).val(_this.design.model_uuid);
          $("[name=design_name]", $form).val(result);

          // Copy sharing from configuration mode if needed
          if (_this.design.is_configuration_mode) {
            $(".details-sharing-form input").each(function (i, el) {
              var name = $(el).attr("name");

              $("[name=" + name + "]", $form).val($(el).val());
              $("[name=" + name + "]", $form).attr(
                "checked",
                $(el).is(":checked")
              );
            });
          }

          $form.submit();
        }
      }
    );
  },

  save_model: function ($el) {
    if (this.save_action) {
      this.save_action($el);
    } else {
      this.default_save_action();
    }

    return false;
  },

  // Retrieves operation, returning a deferred that is resolved upon fetch completion,
  // with the operations loaded into the ui first
  retrieve_operations: function () {
    var _this = this;

    if (!this.retrieve_operations_deferred) {
      // Operations are not fetched yet, trigger the fetch once
      this.retrieve_operations_deferred = $.when(
        this.design.fetch_operation()
      ).then(function (data) {
        _this.load_operation(data);
      });
    }

    return this.retrieve_operations_deferred;
  },

  load_operation: function (data, reload) {
    var ops = {},
      _this = this,
      operations = null;

    if (data.body) {
      operations = data.body;
    } else {
      operations = data.operations;
    }

    for (k in operations) {
      var op_dict = operations[k];

      if (
        op_dict["long"] &&
        !$("#sidebar-tabitems-content").find("#" + op_dict.id).length
      ) {
        var $op = $("<div></div>", { class: "tabitem-content-operation" })
          .html(op_dict["long"])
          .hide();

        $("#sidebar-tabitems-content").append($op);
        ops[op_dict.seq] = [$op, op_dict.id];
      } else if (op_dict["long"] && reload) {
        var $op = $(op_dict["long"]).show();

        $("#sidebar-tabitems-content")
          .find("#" + op_dict.id)
          .replaceWith($op);
        ops[op_dict.seq] = [$op.parent(), op_dict.id];
      }
    }

    $("#content-right .tab-item.tab-with-op").each(function () {
      var tab = TabItemUI.from_el($(this)),
        seq = $(this).data("opseq");

      if (!seq) {
        return;
      }

      if (!ops[seq]) {
        log("ops[" + seq + "] not found");

        // New ops may be present before other operations are fetched
        // $(this).remove();
        if (Object.keys(ops).length == 1) {
          for (seq in ops) {
            break;
          }
        } else {
          return;
        }
      }

      $(this).data("opid", "X" + ops[seq][1]);

      if (!tab.$content) {
        tab.$content = ops[seq][0];
        tab.click(function () {
          SculpteoOperationUI.from_el(
            this.$content,
            _this.design,
            _this.design.operations[ops[seq][1]],
            { small: $(".ShortOperation", this.$tab) }
          ).show();
          var size_display = false;

          if (this.$tab.attr("id") == "material-button") {
            $(".size-select", this.$content).hide();
            $(".available-materials", this.$content).show();

            if (_this.embedded) {
              $(".more-info-materials").hide();
            }
          } else if (this.$tab.attr("id") == "size-button") {
            $(".size-select", this.$content).show();
            $(".available-materials", this.$content).hide();
            size_display = true;
          }

          viewerUI.toggle_display_grid(size_display);
        });
      } else if (reload) {
        tab.update_content(ops[seq][0]);
        SculpteoOperationUI.from_el(
          tab.$content,
          _this.design,
          _this.design.operations[ops[seq][1]]
        ).binded = false;
      }
    });

    // Update configuration UI
    if (configurableUI) {
      configurableUI.set_configuration_state(
        _this.design.is_configuration_mode,
        _this.design.is_configuration_preview_mode
      );
    }
  },

  set_message: function (type, id, msg) {},

  unset_message: function (id) {},
};

function OrderDetailsUI(design, theme) {
  this.design = design;
  var _this = this;

  $.Topic("price-update-result").subscribe(function (data) {
    _this.update_price(data);
    _this.design.order.refreshDeliveryDates(theme);
  });

  $.Topic("price-update-start").subscribe(function (data) {
    _this.price_update_start(data);
  });

  $.Topic("operation-updated").subscribe(function (data) {
    _this.design.order.refreshAmount(theme);
  });

  $.Topic("scale-changed").subscribe(function (data) {
    _this.update_scale_display();
    _this.design.order.refreshDeliveryDates(theme);
  });

  design.order.refreshAmount(theme);
}

OrderDetailsUI.prototype = {
  ready: function () {
    var _design = this.design,
      _this = this;

    $("#Quantity")
      .val(1)
      .on("change keyup", function (evt) {
        if (!$(".sidebar").is(":visible")) {
          // Series mode
          if ($(this).val() < 20) {
            log(
              "error when setting quantity: series mode requires at least 20 items"
            );

            return;
          }
        }

        $.when(_design.order.update_quantity($(this).val()))
          .then(function () {
            if (
              _design.order.quantity > 0 &&
              _design.series.pack &&
              _design.series.pack != _design.order.quantity
            ) {
              _design.update_scale(false, false, false, _design.order.quantity);
            } else {
              _design.order.refreshAmount(_this.theme);
              _design.order.refreshDeliveryDates(_this.theme);
            }
          })
          .fail(function (err) {
            log("error when setting quantity " + concatObject(err));
          });
      });

    $("#Currencies").change(function (evt) {
      $.when(_design.order.update_curreny($(this).val())).then(function () {
        _design.order.refreshAmount();
      });
    });

    if (_design.model_uuid) {
      // Request price if uuid is present when opening the page
      _design.order.refreshAmount(_this.theme);
    }
  },

  price_update_start: function () {
    if (!$(".Button-add-to-cart").hasClass("disabled")) {
      $(".Button-add-to-cart").addClass("disabled");
    }

    if (!$(".Button-confirmation").hasClass("disabled")) {
      $(".Button-confirmation").addClass("disabled");
    }

    if (!$(".Button-series").hasClass("disabled")) {
      $(".Button-series").addClass("disabled");
    }

    $("#Amount, #UnitPrice").html(
      "<img src='" + STATIC_URL + "css/images/loader16.gif'/>&nbsp;"
    );
    $(".designs_price").html("-&nbsp;-&nbsp;-");
    $(".staff-value").html("---");
  },

  price_update_stop: function () {},

  update_series_button: function () {
    if (
      $.inArray(
        this.design.material.slug,
        $(".Button-series").length &&
          $(".Button-series").data("ifmaterial").split(" ")
      ) != -1 &&
      this.design.order.quantity >= 20
    ) {
      // Check object always fits in Arreau printer in any orientation the user could force
      var size = this.design.size.get();
      var scale = this.design.size.unitFactor();

      if (
        size.x * scale < 18.0 &&
        size.y * scale < 18.0 &&
        size.z * scale < 18.0
      ) {
        $(".Button-series").removeClass("disabled");
      }
    }
  },

  update_price: function (data) {
    if (data.error.id == 0) {
      if (!this.design.material) {
        return;
      }

      var response = data.body;

      $("#Amount, #UnitPrice").removeClass("red cleargray");
      if (
        response.price.total_cost != response.price.total_cost_without_discount
      ) {
        // Include discount
        $(".designs_price").html(
          '<span class="strike" style="font-size: 18px; color: red">' +
            response.price.unit_price_without_discount +
            '</span>&nbsp;<span class="bold">' +
            response.price.unit_price +
            "</span>"
        );
      } else {
        $(".designs_price").html(response.price.unit_price);
      }

      $("#Amount").html(response.price.total_cost);

      if ($("#Currencies").length) {
        $("#UnitPrice").html(response.price.unit_price_raw);
      } else {
        $("#UnitPrice").html(response.price.unit_price);
      }

      if (response.price.discount) {
        $("#Discount").text(response.price.discount).parent().show();
      } else {
        $("#Discount").removeClass("red cleargray").text("").parent().hide();
      }

      if (response.warning) {
        $(".display-errors").addClass("active").html(response.warning);
        $(".display-errors").show();
      } else {
        $(".display-errors").removeClass("active").html("");
        $(".display-errors").hide();
      }

      if (
        response.warnings &&
        $.inArray("solidity_will_break", response.warnings) != -1
      ) {
        $(".series-button-next-step2").addClass("disabled");
      } else {
        $(".series-button-next-step2").removeClass("disabled");
      }

      $(".Button-add-to-cart").removeClass("disabled");
      $(".Button-confirmation").removeClass("disabled");
      $("#add-to-cart-warning").hide();
      this.update_series_button();

      // Let's see if we have some finish options to propose
      var count = 0;
      var _this = this;

      $(".finish-ifmaterial").each(function (i, el) {
        if (
          $.inArray(
            _this.design.material.slug,
            $.trim($(el).data("ifmaterial")).split(" ")
          ) != -1
        ) {
          $(el).show();
          count++;
          $(el).attr("disabled", null);
        } else {
          $(el).attr("selected", null);
          $(el).attr("disabled", "disabled");
          $(el).hide();
        }
      });

      if (count > 1) {
        $(".material-finish").show();
      } else {
        $(".material-finish").hide();
      }

      if (response.price.staff_info) {
        $(".staff-volume").html(response.price.staff_info.volume.toFixed(5));
        $(".staff-area").html(response.price.staff_info.area.toFixed(4));
        $(".staff-footprint").html(
          response.price.staff_info.footprint.toFixed(5)
        );
      } else {
        $(".staff-value").html("---");
      }
    } else {
      $("#Amount, #UnitPrice").addClass("red").text(" ###.##");
      $("#Discount").removeClass("red cleargray").text("").parent().hide();
      $(".display-errors").show().html(data.error.description);
      $(".Button-add-to-cart").addClass("disabled");
      $(".Button-confirmation").addClass("disabled");
      $("#add-to-cart-warning").show();
      $(".Button-series").addClass("disabled");

      // Staff info
      $(".staff-value").html("---");
    }

    this.price_update_stop();
    mainUI.toolbar_fit();
  },

  update_scale_display: function (data) {
    var fixed = this.design.size.fixed(1);

    var size_str =
      fixed.x +
      "&nbsp;x&nbsp;" +
      fixed.y +
      "&nbsp;x&nbsp;" +
      fixed.z +
      "&nbsp;" +
      this.design.size.unit;

    $(".print-size.details").html(size_str);
    this.update_series_button();
  },
};

function MaterialUI(design) {
  this.design = design;
}

MaterialUI.prototype = {
  ready: function () {
    var _this = this;

    $.Topic("material-selected").subscribe(function (material) {
      _this.update_material(material);
    });

    $.Topic("material-selected").subscribe(function (material) {
      _this.update_scale_slider();
    });

    $.Topic("bbox-updated").subscribe(function (material) {
      _this.update_scale_slider();
    });

    $.Topic("scale-changed").subscribe(function (new_size, changes) {
      if (changes["unit"]) {
        _this.update_scale_slider();
      }
    });

    this.update_scale_slider();
  },

  update_material: function (material) {
    $(".print-material .thumbnail").attr("src", material.thumb);
    $(".print-material .name").text(material.name);
    $(".material-threshold").text(2 * material.threshold);
    var print_op_ui = $(".PrintDesignOperation").data("ui");

    if (print_op_ui) {
      print_op_ui.update_weight();
    }
  },

  update_scale_slider: function () {
    if (!this.design.material) {
      return;
    }

    var maxScale = this.design.size.maxScale(this.design.material.size) * 1.1,
      minScale = this.design.size.getMinScale(),
      step = (maxScale - minScale) / 100;

    step = Math.log(step) / Math.LN10;
    step = Math.pow(10, Math.round(step));
    $(".PrintDesignOperation .ScaleSlider").slider({
      max: maxScale,
      min: minScale,
      step: step,
    });
  },
};

function ViewerUI(design, viewer_src, front_view_settings) {
  var _this = this;

  this.viewer_ready = false;
  this.waiting_modifications = Array();
  this.design = design;
  this.viewer_src = viewer_src;
  this.front_view_settings = front_view_settings;
  this.solidity_check = false;
  this.sliced_render = false;
  this.display_grid = false;
  this.update_timer = false;
  this.my_handle_viewer_event = null;
  this.design_displayed = false;
  this.solidity_check_labels = {};
  this.demo = false;
  this.viewer_hooks = [];
  this.bg_depends_on_material = false;
  this.viewer = null;
  this.series = { nodes: [], scene: false, view: true, scale: 1.0 };

  // $.Topic("operation-fetched").subscribe(function() { log("load url="+_this.design.op.refreshUrl()); _this.viewer_update({ load: _this.design.op.refreshUrl(), update_geometry: true })});
  this.topics = {
    "operation-updated": function (data) {
      _this.show_design();
      _this.refreshModel(data);
    },

    "viewer-show-model": function (data) {
      _this.show_design();
    },

    "scale-changed": function (data) {
      _this.clear_measurement_tags();
    },

    "wall-thickness-updated": function (data, params) {
      _this.draw_wall_thickness(data, params);
    },

    "material-selected": function (material) {
      _this.adjust_contrast(material);
    },

    "price-update-result": function (data) {
      _this.update_series(data.body);
    },
  };

  for (var t in this.topics) {
    $.Topic(t).subscribe(this.topics[t]);
  }
}

ViewerUI.prototype = {
  ready: function (opts) {
    var _this = this;

    this.$viewer3d = $("#viewer3d");
    this.viewer = this.$viewer3d.Sculpteo3DViewer();
    $("#designs_div").on("click", ".designs_other_view img", function () {
      var src = $(this).attr("alt");

      $(
        ".designs_other_view img, .designs_other_view .button_3D_view"
      ).removeClass("selected");
      $(this).addClass("selected");
      _this.show_image(src);
    });

    $("#designs_div").on(
      "click",
      ".designs_other_view .button_3D_view",
      function () {
        _this.show_design();
      }
    );

    if ($("#designs_div .designs_other_view img").length) {
      $("#designs_div .designs_other_view img:first").click();
    } else {
      if (!opts || !opts["no_show_design"]) {
        this.show_design();
      }
    }

    $("#solidity-checkbox").click(function (evt) {
      evt.stopPropagation();
      _this.toggle_solidity_check($(this).is(":checked"));
    });

    $("#series-checkbox").click(function (evt) {
      evt.stopPropagation();
      _this.toggle_series($(this).is(":checked"));
    });

    $("#series-view-checkbox").click(function (evt) {
      evt.stopPropagation();
      _this.toggle_series_view($(this).is(":checked"));
    });

    $("#viewer-options-icon").click(function () {
      $.mobile.silentScroll($("#viewer-options").offset().top);
      $("#viewer-options").addClass("ui-highlight");
      setTimeout(function () {
        $("#viewer-options").removeClass("ui-highlight");
      }, 3500);

      return false;
    });

    // Cut ui
    this.cut = { enabled: false, axis: "X", direction: "min", value: 0.5 };

    $("#cuts .slider").slider({
      min: 0.0,
      max: 1.0,
      step: 0.01,
      value: 0.5,
      change: function (event, ui) {
        if (_this.cut.enabled == true) {
          _this.cut.value = ui.value;
          _this.update_cut();
        } else {
          _this.cut.enabled = true;
          $("#cuts .leftDirection").css(
            "background",
            "url(" +
              STATIC_URL +
              "css/images/tmpGellule.png) 0px -20px no-repeat transparent"
          );
          $("#cuts .rightDirection").css(
            "background",
            "url(" +
              STATIC_URL +
              "css/images/tmpGellule.png) -35px -20px no-repeat transparent"
          );
          _this.cut.value = ui.value;
          _this.update_cut();
        }
      },

      slide: function (event, ui) {
        if (_this.cut.enabled == true) {
          _this.cut.value = ui.value;
          _this.update_cut();
        } else {
          _this.cut.enabled = true;
          $("#cuts .leftDirection").css(
            "background",
            "url(" +
              STATIC_URL +
              "css/images/tmpGellule.png) 0px -20px no-repeat transparent"
          );
          $("#cuts .rightDirection").css(
            "background",
            "url(" +
              STATIC_URL +
              "css/images/tmpGellule.png) -35px -20px no-repeat transparent"
          );
          _this.cut.value = ui.value;
          _this.update_cut();
        }
      },
    });

    $("#cuts .rightDirection").click(function () {
      $("#cuts .leftDirection").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/tmpGellule.png) 0px 0px no-repeat transparent"
      );
      $("#cuts .rightDirection").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/tmpGellule.png) -35px 0px no-repeat transparent"
      );

      if (_this.cut.enabled == true && _this.cut.direction == "min") {
        _this.cut.enabled = false;
        $("#cuts .rightDirection").css(
          "background",
          "url(" +
            STATIC_URL +
            "css/images/tmpGellule.png) -35px -20px no-repeat transparent"
        );
        _this.viewer_update({ cutAxis: null });
      } else {
        _this.cut.enabled = true;
      }

      _this.cut.direction = "min";
      _this.update_cut();
    });

    $("#cuts .leftDirection").click(function () {
      $("#cuts .leftDirection").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/tmpGellule.png) 0px -20px no-repeat transparent"
      );
      $("#cuts .rightDirection").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/tmpGellule.png) -35px -20px no-repeat transparent"
      );

      if (_this.cut.enabled == true && _this.cut.direction == "max") {
        _this.cut.enabled = false;
        $("#cuts .leftDirection").css(
          "background",
          "url(" +
            STATIC_URL +
            "css/images/tmpGellule.png) 0px 0px no-repeat transparent"
        );
        _this.viewer_update({ cutAxis: null });
      } else {
        _this.cut.enabled = true;
      }

      _this.cut.direction = "max";
      _this.update_cut();
    });

    $("#cuts .selectAxisX").click(function () {
      _this.cut.axis = "X";
      _this.update_cut();
      $("#cuts .selectAxisX").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) 0px 0px no-repeat transparent"
      );
      $("#cuts .selectAxisY").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) -35px 0px no-repeat transparent"
      );
      $("#cuts .selectAxisZ").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) -70px 0px no-repeat transparent"
      );
    });

    $("#cuts .selectAxisY").click(function () {
      _this.cut.axis = "Y";
      _this.update_cut();
      $("#cuts .selectAxisX").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) 0px -21px no-repeat transparent"
      );
      $("#cuts .selectAxisY").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) -35px -21px no-repeat transparent"
      );
      $("#cuts .selectAxisZ").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) -70px -21px no-repeat transparent"
      );
    });

    $("#cuts .selectAxisZ").click(function () {
      _this.cut.axis = "Z";
      _this.update_cut();
      $("#cuts .selectAxisX").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) 0px -42px no-repeat transparent"
      );
      $("#cuts .selectAxisY").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) -35px -42px no-repeat transparent"
      );
      $("#cuts .selectAxisZ").css(
        "background",
        "url(" +
          STATIC_URL +
          "css/images/selectAxis.png) -70px -42px no-repeat transparent"
      );
    });

    // Series UI
    var f = function ($el, axis) {
      var animation = _this.series.orientation_animation;

      if (animation) {
        animation.cancel();
      }

      if (_this.series.orientation_viewer) {
        _this.series.orientation_animation =
          _this.series.orientation_viewer.animateCamera(
            [axis.w, axis.x, axis.y, axis.z],
            undefined,
            1.2,
            1000
          );
      }

      _this.design.update_scale(false, false, false, false, axis);
      $(".orientation-slider").slider(
        "value",
        $(".orientation-slider").slider("value")
      );
      $("#production_job .selectView").removeClass("selected");
      $el.addClass("selected");
    };

    $.Topic("viewer-background-color-changed").subscribe(function (color) {
      $(".selectView").css(
        "backgroundColor",
        "rgb(" + color[0] + "," + color[1] + "," + color[2]
      );

      if (_this.series.orientation_viewer) {
        _this.series.orientation_viewer.setBackgroundColor(
          color[0],
          color[1],
          color[2]
        );
      }
    });

    $("#production_job .selectViewXp").click(function () {
      f($(this), { w: 1, x: 0, y: 1, z: 0 });
    });

    $("#production_job .selectViewYp").click(function () {
      f($(this), { w: 1, x: 1, y: 0, z: 0 });
    });

    $("#production_job .selectViewZp").click(function () {
      f($(this), { w: 1, x: 0, y: 0, z: 0 });
    });

    $("#production_job .selectViewXm").click(function () {
      f($(this), { w: 1, x: 0, y: -1, z: 0 });
    });

    $("#production_job .selectViewYm").click(function () {
      f($(this), { w: 1, x: -1, y: 0, z: 0 });
    });

    $("#production_job .selectViewZm").click(function () {
      f($(this), { w: 0, x: 0, y: 1, z: 0 });
    });

    $("#production_job .series-custom-axis").click(function () {
      var t = _this.series.orientation_viewer.getTransform().split(",");

      _this.design
        .update_scale(undefined, undefined, undefined, undefined, {
          w: t[0],
          x: t[1],
          y: t[2],
          z: t[3],
        })
        .then(function () {
          $.Topic("series-orientation-changed").publish(
            _this.design.series.orientation
          );
        });

      $(".orientation-slider").slider(
        "value",
        $(".orientation-slider").slider("value")
      );
      $("#production_job .selectView").removeClass("selected");
    });

    $("#production_job .series-free-axis").click(function () {
      _this.design
        .update_scale(undefined, undefined, undefined, undefined, {
          w: NaN,
          x: NaN,
          y: NaN,
          z: NaN,
        })
        .then(function () {
          $.Topic("series-orientation-changed").publish(
            _this.design.series.orientation
          );
        });

      $(".orientation-slider").slider(
        "value",
        $(".orientation-slider").slider("value")
      );
      $("#production_job .selectView").removeClass("selected");
    });

    $("#production_job .selectAxisX").css(
      "background",
      "url(" +
        STATIC_URL +
        "css/images/selectAxis.png) 0px -42px no-repeat transparent"
    );
    $("#production_job .selectAxisY").css(
      "background",
      "url(" +
        STATIC_URL +
        "css/images/selectAxis.png) -35px -42px no-repeat transparent"
    );
    $("#production_job .selectAxisZ").css(
      "background",
      "url(" +
        STATIC_URL +
        "css/images/selectAxis.png) -70px -42px no-repeat transparent"
    );
  },

  adjust_contrast: function (material) {
    if (this.series.orientation_viewer) {
      this.series.orientation_viewer.setMaterial(
        this.design.material
          ? this.design.material.encoded()["material"]
          : "white_plastic"
      );

      if (
        !this.design.material ||
        this.design.material.slug.indexOf("black") != -1 ||
        this.design.material.slug.indexOf("brown") != -1
      ) {
        this.series.orientation_viewer.setBackgroundColor(195, 195, 195);
        $(".selectView").css("backgroundColor", "rgb(195,195,195)");
      } else {
        this.series.orientation_viewer.setBackgroundColor(60, 60, 60);
        $(".selectView").css("backgroundColor", "rgb(60,60,60)");
      }
    }

    if (!this.bg_depends_on_material) {
      return;
    }

    if (!this.viewer_alive()) {
      return;
    }

    if (
      material.slug.indexOf("black") != -1 ||
      material.slug.indexOf("brown") != -1
    ) {
      $("#viewer3d-remotectrl").SculpteoViewerControl("color", 195).show();
    } else {
      $("#viewer3d-remotectrl").SculpteoViewerControl("color", 60).show();
    }
  },

  update_cut: function () {
    var viewer = this.$viewer3d.Sculpteo3DViewer();

    // TEMP: port to all viewers and create abstract API
    if (this.cut.enabled) {
      var min, max, margin;
      var a = 1.0,
        b = 0.0,
        c = 0.0,
        d = this.cut.value;

      margin = 0.005;
      viewer.setCutColor(1.0, 0.0, 0.0, margin);

      if (this.cut.axis == "X") {
        a = 1.0;
        b = 0.0;
        c = 0.0;
        d = (this.cut.value - 0.5) * this.design.size.x + this.design.center.x;
      }

      if (this.cut.axis == "Y") {
        a = 0.0;
        b = 1.0;
        c = 0.0;
        d = (this.cut.value - 0.5) * this.design.size.y + this.design.center.y;
      }

      if (this.cut.axis == "Z") {
        a = 0.0;
        b = 0.0;
        c = 1.0;
        d = (this.cut.value - 0.5) * this.design.size.z + this.design.center.z;
      }

      if (this.cut.direction == "min") {
        a = -a;
        b = -b;
        c = -c;
        d = -d;
      }

      viewer.setCutAxis(a, b, c, d);

      viewer.setLocal(true);
    } else {
      viewer._getViewerInstance().clrCutColor();
      viewer._getViewerInstance().clrCutAxis();
      viewer.setLocal(false);
    }
  },

  setup_viewer_ui: function () {
    var viewerUI = this;
    var defaultFont = "arial";
    var panelImageUrl = STATIC_URL + "css/images/remotectrl_white2.png";

    // Create the internal viewer UI
    var viewer = this.$viewer3d.Sculpteo3DViewer();
    var root = viewer.getRootLayer();
    var ui_state = {
      autorotate: true,
      wireframe: false,
      snapshoting: false,
    };

    log("panelImageUrl = " + panelImageUrl);

    // Common function to set a fixed viewpoint
    var set_view = function (t) {
      // Disable autorotate
      ui_state.autorotate = false;
      viewer.setAutorotate(ui_state.autorotate);

      // Reset zoom and pan
      viewer.resetView();

      // Set the rotation
      viewer.setTransform(t);

      // Update autorotate accessory
      cameraMenuItems[0].setAccessory(ui_state.autorotate ? 2 : 0);
    };

    // Function to take a snapshot
    var take_snapshot = function () {
      if (ui_state.snapshoting) {
        return false;
      }

      var url = viewer.getSnapshotUrl(1024, 1024, 2);

      // Avoid cache on the render url
      url = url.replace(URLS["render"], URLS["render_snapshot"]);
      ui_state.snapshoting = true;

      if (viewerUI.solidity_check_labels.length > 0) {
        url += "&thicknessCheck=1";
      }

      // This.setBackgroundImage(panelImage, 0, -32 * 9);
      // $(".loader", $(this)).show();
      Utils.setCookie("sculpteo-render", "inprogress", 0, "/");
      var $iframe = $(
        '<iframe title="Background image" src="' + url + '" class="hidden" />'
      );

      $iframe.appendTo("body");
      (function loop() {
        setTimeout(function () {
          if (Utils.getCookie("sculpteo-render") != null) {
            loop();
          } else {
            ui_state.snapshoting = false;

            // That.setBackgroundImage(panelImage, 0, -32 * 8);
            // $(".loader", button).hide();
            $iframe.remove();
          }
        }, 1000);
      })();
    };

    var panelOriginY = (root.frame.h - (48 * 4 + 32)) / 2;
    var menuImage = viewer.createImage(
      STATIC_URL + "css/images/viewer.menu.ui.png"
    );
    var menuStyle = {
      backgroundColor: { r: 0, g: 0, b: 0, a: 128 },
      borderColor: { r: 0, g: 0, b: 0, a: 255 },
      borderWidth: 1,
      borderRadius: 0,
      font: defaultFont,
      textHeight: 14,
      textColor: { r: 255, g: 255, b: 255, a: 255 },
      selectionColor: { r: 106, g: 164, b: 245, a: 255 },
      frame: { x: 0, y: 0, w: 160, h: 0 },
      accessoryImage: menuImage,
    };

    // Camera menu
    var cameraMenuItems = [
      {
        title: "Autorotate",
        accessory: ui_state.autorotate ? 2 : 0,
        action: function () {
          ui_state.autorotate = !ui_state.autorotate;
          viewer.setAutorotate(ui_state.autorotate);
          this.setAccessory(ui_state.autorotate ? 2 : 0);
        },
      },
      {
        title: "Front view",
        action: function () {
          set_view(viewerUI.front_view_settings);
        },
      },
      {
        title: "Back view",
        action: function () {
          set_view(rotateY90(rotateY90(viewerUI.front_view_settings)));
        },
      },
      {
        title: "Right view",
        action: function () {
          set_view(
            rotateY90(rotateY90(rotateY90(viewerUI.front_view_settings)))
          );
        },
      },
      {
        title: "Left view",
        action: function () {
          set_view(rotateY90(viewerUI.front_view_settings));
        },
      },
      {
        title: "Top view",
        action: function () {
          set_view(
            rotateX90(rotateX90(rotateX90(viewerUI.front_view_settings)))
          );
        },
      },
      {
        title: "Bottom view",
        action: function () {
          set_view(rotateX90(viewerUI.front_view_settings));
        },
      },
    ];

    var cameraMenu = viewer.createUIMenu(
      $.extend(
        {
          items: cameraMenuItems,
        },
        menuStyle
      )
    );

    cameraMenu.setFrame(-4 + 40, panelOriginY + 8);

    // Background submenu
    var backgroundMenuItems = [
      {
        title: "Lightgray",
        action: function () {
          viewer.setBackgroundImage(null);
          viewer.setBackgroundColor(239, 241, 243);
        },
      },
      {
        title: "Darkgray",
        action: function () {
          viewer.setBackgroundImage(null);
          viewer.setBackgroundColor(60, 60, 60);
        },
      },
      {
        title: "Blueprint",
        action: function () {
          viewer.setBackgroundImage(STATIC_URL + "css/images/background3d.jpg");
        },
      },
    ];

    // Rendering menu
    var renderingMenuItems = [
      {
        title: "Background",
        items: backgroundMenuItems,
      },
      /*{
		 title: "Lighting",
		 action: function() {
		 log("show lighting options")
		 }
		 }, */ {
        title: "Wireframe",
        accessory: ui_state.wireframe ? 2 : 0,
        action: function () {
          ui_state.wireframe = !ui_state.wireframe;
          viewer.setWireframe(ui_state.wireframe);
          this.setAccessory(ui_state.wireframe ? 2 : 0);
        },
      },
      {
        title: "Take a snapshot",
        action: function () {
          take_snapshot();
        },
      },
    ];

    var renderingMenu = viewer.createUIMenu(
      $.extend(
        {
          items: renderingMenuItems,
        },
        menuStyle
      )
    );

    renderingMenu.setFrame(-4 + 40, panelOriginY + 8 + 40);

    // Control panel
    var panelImage = viewer.createImage(panelImageUrl);
    var controlPanel = viewer.createUILayer({
      backgroundColor: { r: 0, g: 0, b: 0, a: 128 },
      borderRadius: 4,
    });

    controlPanel.setFrame(-4, panelOriginY, 40, (32 + 8) * 2 - 8 + 2 * 8);

    var buttons = [];

    for (var i = 0; i < 2; i++) {
      var button = viewer.createUIButton({
        backgroundColor: { r: 0, g: 0, b: 0, a: 0 },
        borderWidth: 0,
        borderRadius: 4,
        borderColor: { r: 255, g: 255, b: 255, a: 0 },
        highlightStyle: {
          backgroundColor: { r: 0, g: 0, b: 0, a: 128 },
          borderColor: { r: 106, g: 164, b: 245, a: 255 },
        },
      });

      button.setFrame(4, 8 + i * 40, 32, 32);
      button.index = i;
      buttons.push(button);
    }

    // Camera menu button
    buttons[0].setBackgroundImage(panelImage, 0, -32 * 4);
    buttons[0].click(function () {
      renderingMenu.detach();

      if (!cameraMenu.parentLayer) {
        root.appendChild(cameraMenu);
      } else {
        cameraMenu.detach();
      }
    });

    // Rendering
    buttons[1].setBackgroundImage(panelImage, 0, -32 * 3);
    buttons[1].click(function () {
      cameraMenu.detach();

      if (!renderingMenu.parentLayer) {
        root.appendChild(renderingMenu);
      } else {
        renderingMenu.detach();
      }
    });

    // Measurement
    /*
		 Buttons[2].setBackgroundImage(panelImage, 0, 0);
		 buttons[2].click(function() {
		 });
		 */

    for (var i = 0; i < buttons.length; i++) {
      controlPanel.appendChild(buttons[i]);
    }

    // Control panel animation
    root.appendChild(controlPanel);

    controlPanel.hidden = false;
    controlPanel.hideAnimationDelay = 10000;
    controlPanel.hideAnimationDuration = 1000;
    controlPanel.hideAnimation = function () {
      var deltaT = +new Date() - controlPanel.hideTime;

      deltaT /= controlPanel.hideAnimationDuration;

      if (deltaT < 1.0) {
        controlPanel.hideAnimationTimeout = setTimeout(
          controlPanel.hideAnimation,
          40
        );
      }

      deltaT = 1.0 - (1.0 - deltaT) * (1.0 - deltaT);
      var offset = -4 - 36 * deltaT;

      controlPanel.setFrame(offset, panelOriginY);
    };

    controlPanel.hide = function () {
      controlPanel.hidden = true;
      controlPanel.hideTime = +new Date();
      clearTimeout(controlPanel.hideAnimationTimeout);
      controlPanel.hideAnimationTimeout = setTimeout(
        controlPanel.hideAnimation,
        40
      );
    };

    controlPanel.show = function () {
      clearTimeout(controlPanel.hideTimeout);
      clearTimeout(controlPanel.hideAnimationTimeout);
      controlPanel.setFrame(-4, panelOriginY);
      controlPanel.hidden = false;
    };

    controlPanel.hideTimeout = setTimeout(
      controlPanel.hide,
      controlPanel.hideAnimationDelay
    );

    root.addEventListener("mousemove", function () {
      if (controlPanel.hidden) {
        controlPanel.show();
      }

      clearTimeout(controlPanel.hideAnimationTimeout);
      clearTimeout(controlPanel.hideTimeout);
      controlPanel.hideTimeout = setTimeout(
        controlPanel.hide,
        controlPanel.hideAnimationDelay
      );
    });

    root.addEventListener("click", function () {
      // Close all menus
      cameraMenu.detach();
      renderingMenu.detach();
    });
  },

  viewer_alive: function () {
    var viewer = this.$viewer3d.Sculpteo3DViewer("viewer");

    if (!viewer) {
      return false;
    }

    if (viewer["isAlive"]) {
      return viewer.isAlive();
    }

    return true;
  },

  update_display_grid: function () {
    var opts = this.display_grid_options();

    if (this.design.material && this.display_grid) {
      $.extend(opts, this.design.material.encoded(this.design.size));
    }

    this.viewer_update(opts);
  },

  toggle_display_grid: function (on) {
    if (on && !this.display_grid) {
      this.display_grid = true;
      this.update_display_grid();
    } else if (!on && this.display_grid) {
      this.display_grid = false;
      this.update_display_grid();
    }
  },

  clear_measurement_tags: function () {
    var labels = this.solidity_check_labels;

    for (var i in labels) {
      var label = labels[i];

      label.detach();

      if (label.fcone_node) {
        label.fcone_node.detach();
      }

      if (label.bcone_node) {
        label.bcone_node.detach();
      }

      delete labels[label.key];
    }
  },

  update_series: function (data) {
    var viewer = this.viewer;
    var parts = [this.design];

    if (this.design.partitioning) {
      parts = this.design.partitioning.parts;
    }

    for (var k = 0; k < parts.length; k++) {
      var positions;

      if (arguments[k] && arguments[k].packing) {
        var packing = arguments[k].packing.split(";");

        positions = new Array(packing.length);

        for (var i = 0; i < packing.length; i++) {
          var xyz = packing[i].split(",");

          positions[i] = new Array(xyz.length);

          for (var j = 0; j < xyz.length; j++) {
            positions[i][j] = parseFloat(xyz[j]);
          }
        }

        // log(positions);
        parts[k].series.positions = positions;
      }
    }

    // Assumes all parts share the same printer..
    if (data && data.printer) {
      this.design.series.dimx = data.printer.max_x;
      this.design.series.dimy = data.printer.max_y;
      this.design.series.dimz = data.printer.max_z;
    }

    var dimx = this.design.series.dimx;
    var dimy = this.design.series.dimy;
    var dimz = this.design.series.dimz;

    var height = 0.0,
      previous_height = 0.0;

    for (var k = 0; k < parts.length; k++) {
      var positions = parts[k].series.positions;

      for (var i = 0; i < positions.length; i++) {
        var h = positions[i][2] + positions[i][7] + previous_height;

        if (h > height) {
          height = h;
        }
      }

      previous_height = height;
    }

    $(".series-fill-height").text(height.toFixed(2));
    $.Topic("series-height-changed").publish(height);

    var enabled = this.design.series.enabled && this.series.view;

    if (enabled) {
      var root = viewer.getScene();

      // Set Z axis vertically, with a nice tilt
      viewer.setTransform(
        "-0.9389782309816936,-0.06700343968731012,-0.019478978337352012,0.3368248657915434"
      );

      // Disable remote render
      viewer.setLocal(true);
      viewer.setQuality(1);

      // Setup scene
      if (!this.series.scene) {
        this.series.scene = true;

        this.series.model = root.childNodes[0];

        this.series.box_top = viewer.createNode("series_box_top");
        viewer.createColorCube(1.0, 255, 0, 0, "series_box_top");
        this.series.box_top.setDrawMode(
          Sculpteo3DViewerSceneNode.DRAWMODE_BBOX
        );
        this.series.box_top.setStyle({
          bboxColor: { r: 20, g: 20, b: 200, a: 32 },
        });

        this.series.box_bottom = viewer.createNode("series_box_bottom");
        viewer.createColorCube(1.0, 255, 0, 0, "series_box_bottom");
        this.series.box_bottom.setDrawMode(
          Sculpteo3DViewerSceneNode.DRAWMODE_BBOX
        );
        this.series.box_bottom.setStyle({
          bboxColor: { r: 20, g: 20, b: 20, a: 96 },
        });

        this.series.level = viewer.createNode("series_level");
        viewer.createColorCube(1.0, 0, 0, 255, "series_level");
        this.series.level.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_BBOX);
        this.series.level.setStyle({
          bboxColor: { r: 20, g: 200, b: 20, a: 32 },
        });

        // Hide main model
        if (this.design.partitioning) {
          for (var k = 0; k < parts.length; k++) {
            parts[k].node.setDrawMode(256);
          }
        } else {
          this.series.model.setDrawMode(256);

          // FIXME: goddammit, I really cannot find the place where the viewer is finally done reloading,
          // so yeah, a filthy timeout. I know, it's bad. Really bad.
          setTimeout(function () {
            var viewer_inst = viewer._getViewerInstance();
            viewer_inst.map_nodes[1].drawmode = 0; // trololo
            viewer_inst.setUpdate(true);
          }, 100);
        }

        // Add the box
        root.appendChild(this.series.box_top);
        root.appendChild(this.series.box_bottom);
        root.appendChild(this.series.level);
      }

      var scale_to_cm =
        this.design.size.designerScale *
        this.design.size.userScale *
        this.design.size.unitFactor();

      // Compute design max dimension
      var dmaxd = this.design.size.x;

      if (this.design.size.y > dmaxd) {
        dmaxd = this.design.size.y;
      }

      if (this.design.size.z > dmaxd) {
        dmaxd = this.design.size.z;
      }

      // Compute box max dimension
      var bmaxd = dimx;

      if (dimy > bmaxd) {
        bmaxd = dimy;
      }

      if (dimz > bmaxd) {
        bmaxd = dimz;
      }

      var scale = dmaxd / bmaxd;

      // Make transform to box on screen center
      var st = new Sculpteo3DViewerTransform3D();

      st = st.scale(scale, scale, scale);
      st = st.translate(
        this.design.center.x,
        this.design.center.y,
        this.design.center.z
      );

      var h = height;

      if (h > dimz) {
        h = dimz;
      }

      var t = new Sculpteo3DViewerTransform3D();

      t = t.scale(dimx, dimy, dimz - h);
      t = t.translate(0.0, 0.0, h + (dimz - h) * 0.5 - dimz * 0.5);
      t = st.x(t);
      this.series.box_top.setTransform(t);

      t = new Sculpteo3DViewerTransform3D();
      t = t.scale(dimx, dimy, h);
      t = t.translate(0.0, 0.0, h * 0.5 - dimz * 0.5);
      t = st.x(t);
      this.series.box_bottom.setTransform(t);

      t = new Sculpteo3DViewerTransform3D();
      t = t.scale(dimx, dimy, dimz * 0.0001);
      t = t.translate(0.0, 0.0, height - dimz * 0.5);
      t = st.x(t);
      this.series.level.setTransform(t);

      // Rebuild an array of positions for all parts
      var positions = [];
      var h = 0.0,
        ph = 0.0;

      for (var k = 0; k < parts.length; k++) {
        var part = parts[k];
        var p = part.series.positions;

        for (var i = 0; i < p.length; i++) {
          var x = p[i];
          var y = new Array(8);

          y[0] = x[0]; // Offset height
          y[1] = x[1];
          y[2] = x[2] + ph;
          y[3] = x[3]; // Keep orientation
          y[4] = x[4];
          y[5] = x[5];
          y[6] = x[6];
          y[7] = k; // Remember part index
          positions.push(y);
          var z = x[2] + x[7] + ph;

          if (z > h) {
            h = z;
          }
        }

        ph = h;
      }

      var update = this.series.nodes.length == positions.length;

      // Remove old nodes
      if (!update) {
        for (var i = 0; i < this.series.nodes.length; i++) {
          this.series.nodes[i].detach();
        }
      }

      // Create new ones
      var nodes = [];

      for (var i = 0; i < positions.length; i++) {
        var part = parts[positions[i][7]];

        t = new Sculpteo3DViewerTransform3D();
        t = t.translate(-part.center.x, -part.center.y, -part.center.z);
        t = t.rotateQ(
          positions[i][3],
          positions[i][4],
          positions[i][5],
          positions[i][6]
        );
        t = t.scale(scale_to_cm, scale_to_cm, scale_to_cm);

        if (part.scale) {
          t = t.scale(part.scale, part.scale, part.scale);
        }

        t = t.translate(
          -0.5 * dimx + positions[i][0],
          -0.5 * dimy + positions[i][1],
          -0.5 * dimz + positions[i][2]
        );
        t = st.x(t);

        if (!update) {
          nodes[i] = viewer.createNode(part.node ? part.node.id : "model");
          nodes[i].setTransform(t);

          nodes[i].setStyle({ bboxColor: { r: 200, g: 20, b: 20, a: 128 } });

          if (positions.length > 200) {
            // Limit performance drop
            nodes[i].setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_BBOX);
          } else {
            // Nodes[i].setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_BBOX |
            // Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);
          }

          root.appendChild(nodes[i]);
        } else {
          // This.series.nodes[i].animateTransform(t, 500);
          this.series.nodes[i].setTransform(t);
        }
      }

      if (!update) {
        this.series.nodes = nodes;
      }

      // Update orientation viewer (for free axis)
      if (
        this.design.series.orientation.w != this.design.series.orientation.w
      ) {
        var animation = this.series.orientation_animation;

        if (animation) {
          animation.cancel();
        }

        if (positions.length && this.series.orientation_viewer) {
          this.series.orientation_animation =
            this.series.orientation_viewer.animateCamera(
              [
                positions[0][3],
                positions[0][4],
                positions[0][5],
                positions[0][6],
              ],
              undefined,
              1.2,
              1000
            );
        } else {
          this.series.orientation_animation = null;
        }
      }

      // Update display grid
      this.series.scale = scale;

      if (this.display_grid) {
        this.toggle_display_grid(false);
        this.toggle_display_grid(true);
      }
    } else {
      if (this.series.scene) {
        // Drop scene
        this.series.scene = false;

        for (var i = 0; i < this.series.nodes.length; i++) {
          this.series.nodes[i].detach();
        }

        this.series.nodes = [];

        // Remove box
        this.series.box_top.detach();
        this.series.box_bottom.detach();
        this.series.level.detach();

        this.series.box_top = null;
        this.series.box_bottom = null;
        this.series.level = null;

        this.series.scene = false;

        // Show main model
        if (this.design.partitioning) {
          for (var k = 0; k < parts.length; k++) {
            parts[k].node.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);
          }
        } else {
          this.series.model.setDrawMode(
            Sculpteo3DViewerSceneNode.DRAWMODE_FLAT
          );

          // // FIXME: goddammit, I really cannot find the place where the viewer is finally done reloading,
          // // so yeah, a filthy timeout. I know, it's bad. Really bad.
          setTimeout(function () {
            var viewer_inst = viewer._getViewerInstance();
            viewer_inst.map_nodes[1].drawmode =
              Sculpteo3DViewerSceneNode.DRAWMODE_FLAT; // trololo
            viewer_inst.setUpdate(true);
          }, 100);
        }

        // Restore remote render
        viewer.setQuality(2);
        viewer.setLocal(false);
      }

      // Update display grid
      this.series.scale = 1.0;

      if (this.display_grid) {
        this.toggle_display_grid(false);
        this.toggle_display_grid(true);
      }
    }
  },

  toggle_series: function (on, skip_scale) {
    if (on && this.design.material) {
      if (!this.design.series.enabled) {
        this.design.series.enabled = true;
        $("#series-checkbox").attr("checked", true);

        if (!skip_scale) {
          this.design.update_scale(
            false,
            false,
            false,
            this.design.order.quantity,
            this.design.series.axis
          );
        }

        this.update_series();
      }
    } else {
      if (this.design.series.enabled) {
        this.design.series.enabled = false;
        $("#series-checkbox").attr("checked", false);

        if (!skip_scale) {
          this.design.update_scale(false, false, false, 0, {
            x: NaN,
            y: NaN,
            z: NaN,
            w: NaN,
          });
        }

        this.update_series();
      }
    }
  },

  toggle_series_view: function (on) {
    if (on && this.design.material) {
      if (!this.series.view) {
        this.series.view = true;
        $("#series-view-checkbox").attr("checked", true);
        this.update_series();
      }
    } else {
      if (this.series.view) {
        this.series.view = false;
        $("#series-view-checkbox").attr("checked", false);
        this.update_series();
      }
    }
  },

  get_slice_height: function () {
    return (
      (0.1 * this.design.size.units["mm"]) /
      (this.design.size.designerScale *
        this.design.size.userScale *
        this.design.size.units[this.design.size.unit])
    );
  },

  update_sliced_render: function () {
    if (this.sliced_render) {
      var height = this.get_slice_height();

      this.viewer_update({
        quality: 2,
        sliced: [height, height, height],
        autorotate: false,
      });
    }
  },

  toggle_sliced_render: function (on) {
    if (on) {
      if (!this.sliced_render) {
        this.sliced_render = true;
        this.update_sliced_render();
      }
    } else {
      if (this.sliced_render) {
        this.sliced_render = false;
        this.viewer_update({ quality: 2, sliced: [-1.0, -1.0, -1.0] });
      }
    }
  },

  get_part_from_node: function (node_key) {
    var node = null;

    if (node_key) {
      var nodes = this.viewer.getNodesByName();

      for (var i = 0; i < nodes.length; ++i) {
        var nd = nodes[i];

        if (nd.instance == node_key) {
          node = nd;
          break;
        }
      }
    }

    // Draw wall thickness for a given part (for partitioning)
    // if a part has been forwarded by click event use it
    // otherwise fall back to the design
    if (this.design.partitioning && node && node.part) {
      for (var i = 0; i < this.design.partitioning.parts.length; ++i) {
        if (this.design.partitioning.parts[i] == node.part) {
          return node.part;
        }
      }
    }

    return this.design;
  },

  update_solidity_thresholds: function () {
    var viewer = $("#viewer3d").Sculpteo3DViewer();

    viewer.setLocal(true);

    if (this.design.partitioning) {
      for (var i = 0; i < this.design.partitioning.parts.length; ++i) {
        var part = this.design.partitioning.parts[i];
        var solidity = part.material.threshold;

        part.node.setSolidity(solidity * 0.7, solidity * 2.0);

        if (part.nodes) {
          for (var j = 0; j < part.nodes.length; ++j) {
            part.nodes[j].setSolidity(solidity * 0.7, solidity * 2.0);
          }
        }
      }
    }

    if (this.design.material) {
      var solidity = this.design.material.get_solidity_threshold(
        this.design.size
      );

      this.viewer_update({
        quality: 2,
        bumpnoise: "",
        solidity: [solidity * 0.7, solidity * 2.0],
        autorotate: false,
      });
    } else if (this.design.partitioning) {
      this.viewer_update({
        quality: 2,
        bumpnoise: "",
        solidity: [1 * 0.7, 1 * 2.0],
        autorotate: false,
      });
    }

    viewer.setLocal(false);
  },

  toggle_solidity_check: function (on) {
    var viewer = $("#viewer3d").Sculpteo3DViewer();
    var that = this;

    if (!this.bound_solidity_check_tag_onclick) {
      this.bound_solidity_check_tag_onclick = function (
        x,
        y,
        z,
        dx,
        dy,
        dz,
        node_key
      ) {
        x = parseFloat(x);
        y = parseFloat(y);
        z = parseFloat(z);
        dx = parseFloat(dx);
        dy = parseFloat(dy);
        dz = parseFloat(dz);
        var part = that.design;

        if (node_key) {
          var node = viewer.getNodeByInstance(node_key);
          var transform = null;

          if (node && node.part) {
            part = node.part;
            transform = node.getWorldTransform();
          }
        }

        part
          .measure_wall_thickness(x, y, z, dx, dy, dz, transform)
          .then(function (data) {
            // EVA: FIXME viewer must then use model_uuid for design_uuid
            // case: details page, click on solidity, add a thickness label, then snapshot
            // that.$viewer3d.Sculpteo3DViewer()._getViewerInstance().design_uuid=that.design.model_uuid;
          });
      };
    }

    if (!this.bound_solidity_check_tag_oncamera) {
      this.bound_solidity_check_tag_oncamera = function () {
        // Update ui position when camera moves
        var pointsize = 10;
        var labels = that.solidity_check_labels;
        var world_to_viewport_transform = viewer.getWorldToViewportTransform();

        for (var i in labels) {
          var label = labels[i];

          label.update_position(world_to_viewport_transform);
        }
      };
    }

    if (on && (this.design.material || this.design.partitioning)) {
      if (!this.solidity_check) {
        this.solidity_check = true;

        if (this.design.material) {
          $(".material-threshold").text(2 * this.design.material.threshold);
          $(".print-preview .unit").text(this.design.size.unit);
        }

        this.update_solidity_thresholds();
        $("#solidity-checkbox").attr("checked", true);
        viewer.setForceNodeMap(true);
        viewer.bind("click", this.bound_solidity_check_tag_onclick);
        viewer.bind("camera", this.bound_solidity_check_tag_oncamera);
        viewer.bind("zoom", this.bound_solidity_check_tag_oncamera);
        viewer.bind("pan", this.bound_solidity_check_tag_oncamera);
      }
    } else {
      if (this.solidity_check) {
        viewer.setLocal(true);
        this.solidity_check = false;

        if (this.design.partitioning) {
          for (var i = 0; i < this.design.partitioning.parts.length; ++i) {
            var part = this.design.partitioning.parts[i];

            part.node.setSolidity(-1.0, -1.0);
          }
        }

        this.viewer_update({ quality: 2, solidity: [-1.0, -1.0] });
        $("#solidity-checkbox").attr("checked", false);
        viewer.setForceNodeMap(false);
        viewer.unbind("camera", this.bound_solidity_check_tag_oncamera);
        viewer.unbind("zoom", this.bound_solidity_check_tag_oncamera);
        viewer.unbind("pan", this.bound_solidity_check_tag_oncamera);
        viewer.unbind("click", this.bound_solidity_check_tag_onclick);
        this.clear_measurement_tags();
        viewer.setLocal(false);
      }
    }
  },

  get_local_thickness_minima: function (callback) {
    if (this.no_minima || this.design.manufacturing_type != 1) {
      return;
    }

    var _design = this.design;
    var parts = this.design.partitioning
      ? this.design.partitioning.parts
      : [this.design];
    var thin_dfds = [];

    parts.forEach(function (part) {
      var dfd = jQuery.Deferred();
      var solidity = part.material.get_solidity_threshold(part.size);

      thin_dfds.push(dfd);
      jQuery.get(
        URLS["local_thickness_minima"] +
          "?thickness_threshold=" +
          1.2 * solidity +
          "&uuid=" +
          part.model_uuid,
        function (data) {
          part.thin_points = data;
          dfd.resolve();
        }
      );
    });

    jQuery.when.apply(null, thin_dfds).then(function () {
      var thin_points = [];

      if (_design.partitioning) {
        for (var i = 0; i < parts.length; ++i) {
          var part = parts[i];
          var node = part.node;

          if (!part.thin_points.minima) {
            continue;
          }

          for (var j = 0; j < part.thin_points.minima.length; j++) {
            var minimum, point;

            minimum = part.thin_points.minima[j].slice();
            var scale = part.scale;

            if (!scale) {
              scale = 1;
            }

            var t = [minimum[0], minimum[1], minimum[2], 1];

            t = node.transform.x(t);
            minimum[0] = t[0];
            minimum[1] = t[1];
            minimum[2] = t[2];
            minimum[3] *= scale;

            if (part.thin_points.pos) {
              point = part.thin_points.pos[j].slice();
              point[0] = point[0];
              point[1] = point[1];
              point[2] = point[2];
              point.push(1);
              point = node.transform.x(point);
              point.pop();
              minimum.push(point);
            }

            if (part.thin_points.vec) {
              minimum.push(part.thin_points.vec[j].slice());
            }

            thin_points.push(minimum);
          }
        }

        thin_points.sort(function (a, b) {
          return a[3] > b[3];
        });

        callback({ minima: thin_points });
      } else {
        thin_points = parts[0].thin_points;

        if (thin_points.pos) {
          for (var i = 0; i < thin_points.minima.length; ++i) {
            thin_points.minima[i].push(thin_points.pos[i]);
          }
        }

        callback(thin_points);
      }
    });

    return thin_dfds;

    // Return jQuery.get(URLS["local_thickness_minima"] +
    // "?thickness_threshold=" + 1.2*solidity +
    // "&uuid=" + this.design.model_uuid,
    // callback
    // );
  },

  get_cursor_material: get_cursor_material,

  init_cone_node: function (size, name, invert) {
    var viewer = $("#viewer3d").Sculpteo3DViewer();
    return init_cone_node(
      viewer,
      viewerUI.operationsAvailable.script_id,
      size,
      name,
      invert
    );
  },

  set_up_measurement_cone: function (node, viewer, callback) {
    node.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);
    node.setMaterial(this.get_cursor_material());
    node.setFlags("C:AO");
    var m = viewer.getScene();

    m.appendChild(node);
    viewer.updateSceneTransform();

    if (callback) {
      callback(node);
    }
  },

  load_measurement_cone: function (node_id, transform, fact, callback) {
    var viewer = $("#viewer3d").Sculpteo3DViewer();
    var node;

    if (!this.cone_node || fact != this.fact) {
      this.fact = fact;
      var dfd = this.init_cone_node(this.fact, "measurement_cone_node");
      var _this = this;
      dfd.then(function () {
        _this.cone_node = dfd.cone_node;
        console.log(_this.cone_node);
        node = viewer.createNode(_this.cone_node.id, transform);
        _this.set_up_measurement_cone(node, viewer, callback);
        return node;
      });
    } else {
      node = viewer.createNode(this.cone_node.id, transform);
      this.set_up_measurement_cone(node, viewer, callback);

      return node;
    }
  },

  draw_wall_thickness: function (data, params, name) {
    if (!data.thickness || !data.distance) {
      return;
    }

    var part = params.part;

    if (!part) {
      part = this.design;
    }

    var x = params.x;
    var y = params.y;
    var z = params.z;
    var dx = params.dx;
    var dy = params.dy;
    var dz = params.dz;

    var viewer = $("#viewer3d").Sculpteo3DViewer();
    var that = this;

    var labels = that.solidity_check_labels;
    var pointsize = 10;
    var margin = 20;
    var scale = part.size.designerScale * part.size.userScale;
    var unit = part.size.unit;

    // Create a cube at the intersection location
    var distance = data.distance;
    var thickness = data.thickness;
    var ix = x + distance * dx;
    var iy = y + distance * dy;
    var iz = z + distance * dz;
    var id = "wall_thickness_point_";

    if (!name) {
      var name = "thickness";
    }

    for (var i = 0; i < 32; i++) {
      id += ((Math.random() * 16) | 0).toString(16);
    }

    var defaultFont = "arial";

    // Create label
    var label = viewer.createUILabel({
      font: defaultFont,
      fontWeight: "bold",
      textHeight: 10,
      text: gettext(name) + " " + (thickness * scale).toFixed(2) + "" + unit,
      textColor: { r: 255, g: 255, b: 255, a: 255 },
      backgroundColor: { r: 0, g: 0, b: 0, a: 192 },
      borderColor: { r: 255, g: 255, b: 255, a: 255 },
      borderWidth: 1,
      borderRadius: 4,
    });

    var point = viewer.createUILayer({
      backgroundColor: { r: 0, g: 0, b: 255, a: 255 },
      borderColor: { r: 255, g: 255, b: 255, a: 255 },
      borderRadius: pointsize * 0.5,
      borderWidth: 1,
    });

    var line = viewer.createUILayer({
      backgroundColor: { r: 255, g: 255, b: 0, a: 255 },
      borderColor: { r: 255, g: 255, b: 255, a: 255 },
      borderWidth: 1,
    });

    var container = viewer.createUILayer({});

    container.key = id;
    container.setFrame(0, 0, label.frame.w + 2, label.frame.h + 2 + margin);

    var root = viewer.getRootLayer();

    container.line = line;
    container.appendChild(line);
    container.label = label;
    label.setFrame(0, margin);
    container.appendChild(label);
    labels[container.key] = container;
    var world_to_viewport_transform = viewer.getWorldToViewportTransform();

    container.remove = function () {
      this.detach();

      if (this.fcone_node) {
        this.fcone_node.detach();
      }

      if (this.bcone_node) {
        this.bcone_node.detach();
      }

      var tab = {
        x: x,
        y: y,
        z: z,
        type: "delete",
        state: 0,
        dx: dx,
        dy: dy,
        dz: dz,
      };

      that.design.list_wall_thickness.push(tab);
      that.design.run_list_queue();
      delete labels[container.key];
    };

    if (data.pos) {
      line.setFrame(container.frame.w * 0.5, 0, 0, margin);
      var size = viewerUI.viewer.getSceneSize();
      var fact = (1 / 10) * Math.min(size.x, size.y, size.z);

      var p = [ix, iy, iz];

      var n = [data.pos[0] - ix, data.pos[1] - iy, data.pos[2] - iz];
      var sz = Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);

      n[0] /= sz;
      n[1] /= sz;
      n[2] /= sz;
      var n2 = [-n[0], -n[1], -n[2]];

      var extPos = [p[0] - n[0] * fact, p[1] - n[1] * fact, p[2] - n[2] * fact];
      var extPos2 = [
        data.pos[0] - n2[0] * fact,
        data.pos[1] - n2[1] * fact,
        data.pos[2] - n2[2] * fact,
      ];

      container.e = [p[0], p[1], p[2], 1];
      container.p = [extPos[0], extPos[1], extPos[2], 1];

      var transform = new Sculpteo3DViewerTransform3D();
      var angle = Math.acos(
        Sculpteo3DViewerTransform3D.dotProduct(n, [0, 0, 1])
      );
      var v = Sculpteo3DViewerTransform3D.crossProduct([0, 0, 1], n);

      transform = transform.rotate(angle, v[0], v[1], v[2]);
      transform = transform.translate(extPos[0], extPos[1], extPos[2]);

      var transform2 = new Sculpteo3DViewerTransform3D();
      var v2 = Sculpteo3DViewerTransform3D.crossProduct([0, 0, 1], n2);
      var angle2 = Math.acos(
        Sculpteo3DViewerTransform3D.dotProduct(n2, [0, 0, 1])
      );

      transform2 = transform2.rotate(angle2, v2[0], v2[1], v2[2]);
      transform2 = transform2.translate(extPos2[0], extPos2[1], extPos2[2]);

      container.prev = 0;
      container.update_position = function (world_to_viewport_transform) {
        var E = world_to_viewport_transform.x(this.e);
        var P = world_to_viewport_transform.x(this.p);

        if (E[1] - P[1] < 0) {
          this.setFrame(P[0] - this.frame.w * 0.5 - 1, P[1] - 1);

          if (this.prev >= 0) {
            this.label.setFrame(0, margin);
            this.line.setFrame(this.frame.w * 0.5, 0);
            this.prev = -1;
          }
        } else {
          this.setFrame(P[0] - this.frame.w * 0.5 - 1, P[1] - this.frame.h + 1);

          if (this.prev <= 0) {
            this.label.setFrame(0, 0);
            this.line.setFrame(this.frame.w * 0.5, this.frame.h - margin);
            this.prev = 1;
          }
        }
      };

      var _this = this;

      this.load_measurement_cone(
        "f" + container.key,
        transform,
        fact,
        function (node) {
          container.fcone_node = node;

          // Container.fcone_node.addEventListener("click", deleteOnClick);
          container.bcone_node = _this.load_measurement_cone(
            "b" + container.key,
            transform2,
            fact,
            function (node) {
              container.bcone_node = node;

              // Container.bcone_node.addEventListener("click", deleteOnClick);
            }
          );

          container.update_position(world_to_viewport_transform);
          root.appendChild(container);
        }
      );
    } else {
      point.setFrame(
        (container.frame.w - pointsize) * 0.5,
        0,
        pointsize,
        pointsize
      );
      line.setFrame(container.frame.w * 0.5, 0.5 * pointsize, 0, margin);
      container.appendChild(point);
      container.update_position = function (world_to_viewport_transform) {
        var P = world_to_viewport_transform.x(this.p);

        this.setFrame(
          P[0] - container.frame.w * 0.5 - 1,
          P[1] - pointsize * 0.5 - 1
        );
      };

      container.p = [ix, iy, iz, 1];
      container.update_position(world_to_viewport_transform);
      root.appendChild(container);
    }

    // Remove on click
    container.click(function () {
      this.remove();
    });

    return container;
  },

  toggle_get_face_index: function (on, callback) {
    var viewer = $("#viewer3d").Sculpteo3DViewer();

    if (on && !this.get_face_index) {
      var _this = this;

      this.get_face_index = function (x, y, z, dx, dy, dz, node_key) {
        if (typeof x === "string") {
          x = parseFloat(x);
        }
        if (typeof y === "string") {
          y = parseFloat(y);
        }
        if (typeof z === "string") {
          z = parseFloat(z);
        }
        if (typeof dx === "string") {
          dx = parseFloat(dx);
        }
        if (typeof dy === "string") {
          dy = parseFloat(dy);
        }
        if (typeof dz === "string") {
          dz = parseFloat(dz);
        }
        var node = viewer.getNodeByInstance(node_key);
        var part = _this.design;

        if (node && node.part) {
          part = node.part;
        }

        part
          .get_face_index(x, y, z, dx, dy, dz, node.getWorldTransform())
          .then(function (data) {
            if (callback) {
              callback(data.face, part);
            }
          });
      };

      viewer.bind("click", this.get_face_index);
    } else if (!on) {
      this.get_face_index = undefined;
      viewer.unbind("click", this.get_face_index);
    }
  },

  on_move_cursor: function (x, y) {
    console.log(viewer.getCursorTransform(x, y).toQuat());
  },

  toggle_fast_rotation: function (on, callback, facing_axis, sz) {
    if (!facing_axis) facing_axis = CameraRotation.Z_AXIS;
    var viewer = $("#viewer3d").Sculpteo3DViewer();
    var modelNode = viewer.getNodesByName("model")[0];
    var _this = this;
    var _callback = function (q, n) {
      var q = [
        Math.round(q[0] * 10000) / 10000,
        Math.round(q[1] * 10000) / 10000,
        Math.round(q[2] * 10000) / 10000,
        Math.round(q[3] * 10000) / 10000,
      ];

      if (callback) {
        q = callback(q, n);
      }

      viewer.animateCamera(q, undefined, 1.2, 1000);
      console.log(q);
    };

    var _this = this;

    if (on && !this.cmptQuatFrmCrsr) {
      this.cmptQuatFrmCrsr = function (x, y, rox, roy, roz, rdx, rdy, rdz) {
        console.log("---------");
        var n = viewer.getCursorNormal(x, y);

        console.log(viewer.getCursorTransform(x, y).toQuat());

        if (!n) {
          return;
        }

        var rotq = CameraRotation.buildQuaternionFromUtoV(facing_axis, n);

        _callback(rotq, n);
      };
      if (!sz) {
        var size = viewerUI.design.size;
        var sz = (1 / 10) * Math.min(size.x, size.y, size.z);
      }

      dfd = this.init_cone_node(sz, "fast_rot_cone");
      dfd.then(function () {
        _this.cone_cursor = dfd.cone_node;
        viewer.setCursorNode(_this.cone_cursor);
        _this.cone_cursor.setMaterial(_this.get_cursor_material());
        _this.cone_cursor.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);
        viewer.setLocal(true);
        modelNode.addEventListener("click", _this.cmptQuatFrmCrsr);
        _this.cone_cursor.addEventListener("move", _this.on_move_cursor);
      });
    } else if (!on) {
      modelNode.removeEventListener("click", _this.cmptQuatFrmCrsr);
      viewer.setCursorNode(null);

      if (this.cone_cursor) {
        this.cone_cursor.destruct();
      }

      this.cmptQuatFrmCrsr = undefined;
      viewer.setLocal(false);
    }
  },

  show_image: function (src) {
    this.design_displayed = false;

    if (this.viewer_alive()) {
      $("#Sculpteo3DViewerSelect").addClass("hidden");
      this.viewer_update({ bgImage: src, set3d: false });
    } else {
      $("#main-image").attr({ src: src });
    }

    $("#viewer3d-remotectrl").hide();
  },

  show_design: function () {
    if (this.design_displayed) {
      return;
    }

    this.design_displayed = true;
    $("#3dPicture").hide();

    if (this.viewer_alive()) {
      this.viewer_update({ unsetBgImage: true, fading: false, set3d: true });
      $("#viewer3d-remotectrl").show();
    } else {
      this.launch_viewer();
    }

    $(".designs_other_view img").removeClass("selected");
    $(".designs_other_view .button_3D_view").addClass("selected");
  },

  register_viewer_hook: function (f) {
    this.viewer_hooks.push(f);
  },

  unregister_viewer_hook: function (f) {
    var vhtmp = [];

    for (var k = 0; k < this.viewer_hooks.length; k++) {
      if (this.viewer_hooks[k] != f) {
        vhtmp.push(this.viewer_hooks[k]);
      }
    }

    this.viewer_hooks = vhtmp;
  },

  launch_viewer: function (options) {
    var viewer = this.$viewer3d.Sculpteo3DViewer();

    // Create a node for each design part
    var parts = this.design.partitioning ? this.design.partitioning.parts : [];

    for (var k = 0; k < parts.length; k++) {
      var part = parts[k];

      part.node = viewer.createNode("part" + k);
      part.node.part = part;

      if (part.scale) {
        part.node.setTransform(
          new Sculpteo3DViewerTransform3D().scale(
            part.scale,
            part.scale,
            part.scale
          )
        );
      }

      // Listen to bbox event
      if (part._bbox_dfd) {
        part.node._bbox_dfd_listener = function () {
          this.part._bbox_dfd.resolve.apply(this.part, arguments);
          this.removeEventListener("bbox", this._bbox_dfd_listener);
        };

        part.node.addEventListener("bbox", part.node._bbox_dfd_listener);
      }
    }

    var opts = this.design.material
        ? this.design.material.encoded(
            this.design.size,
            null,
            null,
            this.design
          )
        : { material: "white_plastic" },
      _this = this;

    if (options) {
      $.extend(opts, options);
    }

    this.loaded_age = -1;
    this.loading_age = 0;

    if (
      !this.design.manufacturing_type ||
      this.design.manufacturing_type == "1"
    ) {
      if (this.design.model_uuid || this.design.explode) {
        this.loading_age = this.design.age;
        var load = {};

        if (parts.length) {
          for (var k = 0; k < parts.length; k++) {
            var part = parts[k];

            if (part.viewer_file) {
              load["part" + k] = part.viewer_file;

              // Patch here the model uuid or design uuid to get correctly the uuid in the viewers
              if (part.model_uuid) {
                load["part" + k].uuid = part.model_uuid;
              } else {
                load["part" + k].uuid = part.design_uuid;
              }
            } else {
              load["part" + k] = part.model_url();
            }

            viewer.getScene().appendChild(part.node);
          }

          $.extend(opts, {
            age: this.design.age,
            load: load,
            designUUID: this.design.model_uuid,
          });
        } else {
          if (this.design.viewer_file) {
            load["model"] = this.design.viewer_file;

            // Patch here the model uuid or design uuid to get correctly the uuid in the viewers
            if (this.design.model_uuid) {
              load["model"].uuid = this.design.model_uuid;
            } else {
              load["model"].uuid = this.design.design_uuid;
            }
          } else {
            load["model"] = this.design.model_url();
          }

          $.extend(opts, {
            age: this.design.age,
            load: load,
            src: this.design.model_url(),
          });
        }
      } else {
        opts["src"] = this.viewer_src;
        opts["rendercache"] = true;
      }
    } else {
      this.loaded_age = this.loading_age = this.design.age;
      opts["autorotate"] = false;
    }

    if (this.scene) {
      var id;

      // Patch src of model if needed
      var src = this.design.model_uuid
        ? this.design.model_url()
        : this.viewer_src;

      for (id in this.scene.models) {
        if (id == "model" && src) {
          this.scene.models[id] = src;
        }
      }

      delete opts["src"];

      log("parsing scene");
      var load_scene = function (node) {
        // TODO: handle scene graph; here we union all the non-operation nodes
        if (node.id) {
          var n = viewer.createNode(
            node.id,
            node.transform ? node.transform.toString() : undefined,
            node.material
          );

          viewer.getScene().appendChild(n);
        }

        if (node.operation) {
          load_scene(node.A);
          load_scene(node.B);
        }
      };

      viewer.clearScene();
      load_scene(this.scene.root);

      if (typeof opts.load == "string") {
        opts.load = { model: opts.load };
      }

      if (typeof opts.load != "undefined") {
        if (!opts.load["model"]) {
          opts.load["model"] = opts.src;
        }

        delete opts.src;
      }

      opts.load = opts.load || {};

      for (id in this.scene.models) {
        var m = this.scene.models[id];

        log("add model for loading");
        log(m);
        opts.load[id] = m;
      }
    }

    $.extend(opts, {
      uuid: Utils.uniqueString(),
      envmapurl: URLS["envmap"],
      cubemapurl: URLS["cubemap"],
      eventhandler: function (args) {
        _this.handleViewerEvent(args);
      },

      transform: this.front_view_settings,
    });
    _this.$viewer3d.show().Sculpteo3DViewer(opts);

    if (jQuery().SculpteoViewerControl) {
      var control_options = $.extend({ bgcolor: 239 }, opts);

      $("#viewer3d-remotectrl").SculpteoViewerControl(
        _this.$viewer3d,
        control_options
      );
    }
  },

  set_solidity_check: function (toggle) {
    this.solidity_check = toggle;
    this.requestModel();
  },

  display_grid_options: function () {
    if (!this.display_grid) {
      return {
        unitmm: 0.0,
      };
    }

    if (this.design.partitioning) {
      // In the case of parts the scale in the viewer is taken from the scene size, not the model
      // Hence the scale is 2
      var scale = 2;
    } else {
      var scale = this.design.size.scaleFactor();
    }

    if (this.series.scale) {
      scale *= this.series.scale;
    }

    return {
      unitmm: scale.toFixed(12),
    };
  },

  handleViewerEvent: function (args) {
    var evt = String(args[0]),
      _this = this;

    if (evt == "init") {
      this.viewer_ready = true;
    } else if (evt == "click") {
      args.shift();
      var t = "" + this.$viewer3d.Sculpteo3DViewer("viewer").getTransform();
      var rot_w = t.split(/,/)[0];
      var rot_x = t.split(/,/)[1];
      var rot_y = t.split(/,/)[2];
      var rot_z = t.split(/,/)[3];
      var pos = {
        position_x: args[0],
        position_y: args[1],
        position_z: args[2],
        direction_x: args[3],
        direction_y: args[4],
        direction_z: args[5],
        rotation_w: rot_w,
        rotation_x: rot_x,
        rotation_y: rot_y,
        rotation_z: rot_z,
      };

      $.Topic("viewer-click").publish(pos);
    } else if (args[0] == "progress") {
      if (this.loading_age != -1) {
        if (this.design.model_uuid) {
          this.loaded_age = this.loading_age;
        } else {
          this.loaded_age = 0;
        }

        if (this.design.model_uuid && this.design.age > this.loaded_age) {
          log("more recent age, reload");
          this.loading_age = this.design.age;
          this.viewer_update({
            load: this.design.model_url(),
            age: this.design.age,
          });
        } else {
          log("latest design loaded at age " + this.design.age);
          this.loading_age = -1;
          this.on_model_loaded();

          if (typeof mainUI != "undefined" && mainUI.bbox_need_refresh) {
            _this.refresh_bbox();
          }
        }
      }
    } else if (args[0] == "errorMessage") {
      var errorMessage = args[1];

      this.on_viewer_error(errorMessage);
      this.loading_age = -1;
      this.design.reload_operations();
    } else if (args[0] == "waitJob") {
      var _this = this;
      var params = args[1].split(";");
      var worker_job = {
        uuid: params[1],
        age: parseInt(params[2]),
      };
      _this.viewer.setLocal(true);
      sculpteoJob([worker_job])
        .done(function (job, msg) {
          _this.viewer.setLocal(false);
        })
        .success(function (job, msg) {
          _this.viewer.loadModel(params[3], "model");
        })
        .failure(function (job, msg) {
          _this.on_viewer_error(params[0]);
          _this.loading_age = -1;
          _this.design.reload_operations();
        });
    } else if (args[0] == "interrupted") {
      log("409 interrupted");
      log("url = " + args[1]);
      log("loaded age: " + this.loaded_age + " current age:" + this.design.age);

      if (this.design.model_uuid && this.design.age > this.loaded_age) {
        log("reloading");
        this.loading_age = this.design.age;
        this.viewer_update({
          load: this.design.model_url(),
          age: this.design.age,
        });
      } else {
        log("not reloading interrupted");
      }
    }

    if (this.my_handle_viewer_event) {
      this.my_handle_viewer_event(args);
    }
  },

  refresh_bbox: function () {
    var _this = this;

    if (!this.ajax_bbox) {
      this.ajax_bbox = new AjaxHandler({
        delay: 1000,
        success: function (data) {
          if (data.dimensions) {
            _this.design.size.x = data.dimensions[0];
            _this.design.size.y = data.dimensions[1];
            _this.design.size.z = data.dimensions[2];
            $.Topic("scale-changed").publish(_this.design);
            $.Topic("bbox-updated").publish();

            if (data.volume) {
              _this.design.volume = data.volume;
            } else {
              _this.design.volume = 0.0;
            }

            var print_op_ui = $(".PrintDesignOperation").data("ui");

            if (print_op_ui) {
              print_op_ui.update_weight();
            }
          } else if (data.error) {
            var size_str = "--&nbsp;x&nbsp;--&nbsp;x&nbsp;--";

            $(".print-size.details").html(size_str);
          }
        },
      });
    }

    this.ajax_bbox.add(URLS["x_get_bbox"] + "?uuid=" + _this.design.model_uuid);
  },

  on_model_loaded: function () {
    // $("#Sculpteo3DViewerSelect").hide();
  },

  on_viewer_error: function (errorMessage) {
    $.alerts.horizontalOffset = 200;
    jAlert("" + gettext(errorMessage), gettext("Error"));
  },

  refreshModel: function (options) {
    var _this = this;

    if (this.update_timer) {
      clearTimeout(this.update_timer);
    }

    this.update_timer = setTimeout(function () {
      _this.requestModel(options);
    }, 0);
  },

  requestModel: function (options) {
    if (
      options &&
      typeof options.can_apply != "undefined" &&
      !options.can_apply
    ) {
      log("Can not apply operation yet");

      return;
    }

    var viewer_options = {};

    if (options && typeof options.update_geometry != "undefined") {
      viewer_options.update_geometry = options.update_geometry;
    }

    if (options && typeof options.update_material != "undefined") {
      viewer_options.update_material = options.update_material;
    }

    if (this.design.material != null) {
      viewer_options.update_material = false;
    }
    /*
		There is a flaw here. To get the perlin, we need the bbox.
		But he bbox used to compute the perlin is the one of the current model, not
		the one of the model which is about to be computed.
		To solve that, we should retrieve, in a first step, the bbox, the ask for a refresh.
		It's a bit tricky (must handle errors on get_bbox, put the bbox url in 3D, handle 409 on requests...)
		*/
    /* Update viewer */
    $.extend(viewer_options, this.display_grid_options());

    if (this.design.material) {
      if (this.display_grid) {
        $.extend(
          viewer_options,
          this.design.material.encoded(this.design.size)
        );
      } else {
        $.extend(viewer_options, this.design.material.encoded());
      }

      if (this.solidity_check) {
        solidity = this.design.material.get_solidity_threshold(
          this.design.size
        );
        $.extend(viewer_options, {
          quality: 2,
          bumpnoise: "",
          solidity: [solidity * 0.7, solidity * 1.2],
          autorotate: false,
        });
      } else {
        $.extend(viewer_options, { quality: 2, solidity: [-1.0, -1.0] });
      }
    }

    // $.extend(viewer_options, M_preview.get_viewer_options());
    if (this.design.model_uuid) {
      var age = this.design.age;
      var parts = this.design.partitioning
        ? this.design.partitioning.parts
        : [];

      for (var k = 0; k < parts.length; k++) {
        if (parts[k].age > age) {
          age = parts[k].age;
        }
      }

      if (
        (this.loaded_age < age && this.loading_age == -1) ||
        (options && options.force_refresh)
      ) {
        log("loading (age " + this.loaded_age + " < " + age + ")");
        $.extend(viewer_options, {
          age: age,
          rendercache: false,
        });

        // Load model for subparts...
        var parts = this.design.partitioning
          ? this.design.partitioning.parts
          : [];
        var dfds = [];
        var that = this;

        for (var k = 0; k < parts.length; k++) {
          var part = parts[k];

          dfds.push(parts[k].node.load(part.model_url()));
        }

        // ... or load main model
        if (!parts.length) {
          $.extend(viewer_options, { load: this.design.model_url() });
        }

        var viewer = this.$viewer3d.Sculpteo3DViewer();

        $.when.apply(null, dfds).then(function () {
          viewer.clearStatusMessage();
          that.viewer_update(viewer_options);
        });

        return;
      } else {
        log(
          "not reloading: age (loaded=" +
            this.loaded_age +
            " loading=" +
            this.loading_age +
            " age=" +
            this.design.age +
            ")"
        );
      }
    }

    this.viewer_update(viewer_options);
  },

  viewer_update: function (options) {
    var _this = this;

    if (this.viewer_ready) {
      if (!options || $.isEmptyObject(options)) {
        if (this.waiting_modifications.length) {
          options = this.waiting_modifications.shift();
        } else {
          return;
        }

        log(
          "viewer is ready, shifting waiting operations: { " +
            concatObject(options) +
            "}"
        );
      }

      if (options.age && options.load) {
        this.loading_age = options.age;
      }

      log("Viewer update " + concatObject(options));
      this.$viewer3d.Sculpteo3DViewer(options);
      /* Comment out whole if, not just its contents
			if (options && options.update_geometry) {
				M_size.update_bbox = true;
			}
*/
    } else {
      if (options && !$.isEmptyObject(options)) {
        log(
          "viewer is not yet ready, pushing { " + concatObject(options) + "}"
        );
        this.waiting_modifications.push(options);
      }

      setTimeout(function () {
        _this.viewer_update();
      }, 300);
    }
  },
};

var OrderConfirmationUI = function (design) {
  this.design = design;
  var _this = this;

  this.slided = Array();
  this.action = function () {
    _this.default_action();
  };
};

OrderConfirmationUI.prototype = {
  ready: function () {
    var _this = this;

    this.init_values();

    var $cartButton = $(".Button-add-to-cart"),
      $confirmationButton = $(".Button-confirmation"),
      $seriesButton = $(".Button-series"),
      $checkbox = $("[name=check_confirmation]"),
      $confirmationDiv = $("#order-confirmation");

    $seriesDiv = $("#series-step1");
    $(".back-to-order").on("click", function (evt) {
      $confirmationDiv.slideUp();
      $seriesDiv.slideUp();
      _this.toggle_series_mode(false);
      viewerUI.toggle_solidity_check(false);

      while (_this.slided.length != 0) {
        $(_this.slided.pop()).slideDown("fast");
      }

      $(".series-navigation").hide();
      $(".series-price-rightbox").show();
      $("#series-unit-price").hide();

      return false;
    });

    // $(".print_scale_preview .link").click(sizeUI.print_scale_preview);

    $confirmationButton.on("click", function (evt) {
      $.Topic("ui-cart-button").publish({ action: "clicked" });

      if (!$(this).is(".disabled")) {
        TabItemUI.hide();
        $.each(
          $("#fragment_detail_options").children(
            ":visible:not(.designs_price)"
          ),
          function (i, el) {
            _this.slided.push(el);
            $(el).slideUp("fast");
          }
        );

        $.each(
          $("#fragment_detail_order").children(":visible"),
          function (i, el) {
            _this.slided.push(el);
            $(el).slideUp("fast");
          }
        );

        $confirmationDiv.slideDown();

        if ($checkbox.length != 0) {
          $checkbox.removeAttr("checked");
          $cartButton.addClass("disabled");
        }

        var s = _this.design.size.fixed(1);

        $(".x_dim").html(s.x);
        $(".y_dim").html(s.y);
        $(".z_dim").html(s.z);
        $(".unit").html(_this.design.size.unit);
        $(".confirm-material_name").html(_this.design.material.name);
        viewerUI.toggle_solidity_check(false);
      }
    });

    $checkbox.on("click", function (evt) {
      $cartButton.toggleClass("disabled", !$(this).is(":checked"));
    });

    $cartButton.on("click", function (evt) {
      if ($cartButton.hasClass("disabled")) {
        return;
      }

      if ($checkbox.length == 0 || $checkbox.is(":checked")) {
        $("#confirm-reqs").slideUp();
        _this.action();
        $cartButton.addClass("disabled");

        if ($(".processing", $cartButton).length) {
          $(".add", $cartButton).hide();
          $(".processing", $cartButton).show();
        }
      } else {
        $("#confirm-reqs").slideDown();
        Utils.show_lateral_alert_right({
          msg_class: "check_confirmation_alert",
          target_el_selector: "input[name=check_confirmation]",
          hideAfter: true,
          offsetLeft: 200,
          offsetTop: -30,
        });
        $checkbox.focus();
      }
    });

    $seriesButton.on("click", function (evt) {
      if (!$(this).is(".disabled")) {
        $("#batch-reqs").slideUp();
        $(".detail-hint-wrapper").hide();
        TabItemUI.hide();
        $.each(
          $("#fragment_detail_options").children(
            ":visible:not(.designs_price,#delivery-display-box)"
          ),
          function (i, el) {
            _this.slided.push(el);
            $(el).hide();
          }
        );

        $.each(
          $("#fragment_detail_order").children(":visible"),
          function (i, el) {
            _this.slided.push(el);
            $(el).hide();
          }
        );

        _this.toggle_series_mode(true);

        if ($checkbox.length != 0) {
          $checkbox.removeAttr("checked");
          $cartButton.addClass("disabled");
        }

        var s = _this.design.size.fixed(1);

        $(".x_dim").html(s.x);
        $(".y_dim").html(s.y);
        $(".z_dim").html(s.z);
        $(".unit").html(_this.design.size.unit);
        $(".confirm-material_name").html(_this.design.material.name);
        viewerUI.toggle_solidity_check(true);

        $(".series-price-rightbox").hide();
        $("#series-order-details-box").hide();
      } else {
        $("#batch-reqs").slideDown();
      }
    });

    $(".series-button-next-step2").on("click", function (evt) {
      if ($(this).hasClass("disabled")) {
        return false;
      }

      $("#series-step1").hide();
      $("#series-step2").show();
      $("#series-navigation-step1").removeClass("series-navigation-active");
      $("#series-navigation-step1").addClass("series-navigation-done");
      $("#series-navigation-step2").addClass("series-navigation-active");
      $("#series-navigation-step2").removeClass("series-navigation-not-yet");
      $(".series-navigation-indicator").removeClass(
        "series-navigation-indicator1"
      );
      $(".series-navigation-indicator").addClass(
        "series-navigation-indicator2"
      );
      $("#series-order-details-box").show();
      $(".series-price-rightbox").show();
      $("#series-unit-price").show();
      viewerUI.toggle_series(true);
      viewerUI.toggle_solidity_check(false);

      // Compute thumbnails
      url =
        viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: "1,0,1,0",
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      $(".selectViewXp").css("backgroundImage", "url(" + url + ")");
      url =
        viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: "1,1,0,0",
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      $(".selectViewYp").css("backgroundImage", "url(" + url + ")");
      url =
        viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: "1,0,0,0",
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      $(".selectViewZp").css("backgroundImage", "url(" + url + ")");

      url =
        viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: "-1,0,1,0",
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      $(".selectViewXm").css("backgroundImage", "url(" + url + ")");
      url =
        viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: "-1,1,0,0",
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      $(".selectViewYm").css("backgroundImage", "url(" + url + ")");
      url =
        viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: "0,0,1,0",
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      $(".selectViewZm").css("backgroundImage", "url(" + url + ")");
    });

    $(".series-button-prev-step2").on("click", function (evt) {
      $("#series-step1").show();
      $("#series-step2").hide();
      $("#series-navigation-step1").addClass("series-navigation-active");
      $("#series-navigation-step1").removeClass("series-navigation-done");
      $("#series-navigation-step2").removeClass("series-navigation-active");
      $("#series-navigation-step2").addClass("series-navigation-not-yet");
      $(".series-navigation-indicator").addClass(
        "series-navigation-indicator1"
      );
      $(".series-navigation-indicator").removeClass(
        "series-navigation-indicator2"
      );
      $("#series-order-details-box").hide();
      $(".series-price-rightbox").hide();
      $("#series-unit-price").hide();
      viewerUI.toggle_series(false);
      viewerUI.toggle_solidity_check(true);
    });

    var material_finish_data = {};

    if ($(".material-finish-data").length) {
      material_finish_data = eval(
        "(" + $(".material-finish-data").text() + ")"
      );

      for (var k in material_finish_data) {
        material_finish_data[k] = new Material(material_finish_data[k]);
      }
    }

    var material_layer_data = {};

    if ($(".material-layer-data").length) {
      material_other_layer_option_data = eval(
        "(" + $(".material-layer-data").text() + ")"
      );

      for (var k in material_other_layer_option_data) {
        material_other_layer_option_data[k] = new Material(
          material_other_layer_option_data[k]
        );
      }
    }

    $(".material-layer-thickness").change(function () {
      viewerUI.design.update_material(
        material_other_layer_option_data[$(this).val()]
      );
    });

    $(".series-button-next-step3").on("click", function (evt) {
      var d = material_other_layer_option_data[viewerUI.design.material.id];

      if (d) {
        $(".SelectLayer").show();

        if (d.layer_thickness == 60) {
          $(".material-layer-thickness-100u")
            .attr("value", d.id)
            .attr("selected", "selected");
          $(".material-layer-thickness-60u")
            .attr("value", viewerUI.design.material.id)
            .attr("selected", null);
        } else {
          $(".material-layer-thickness-60u")
            .attr("value", d.id)
            .attr("selected", "selected");
          $(".material-layer-thickness-100u")
            .attr("value", viewerUI.design.material.id)
            .attr("selected", null);
        }
      } else {
        $(".SelectLayer").hide();
      }

      $("#series-step2").hide();
      $("#series-step3").show();
      $("#series-navigation-step2").removeClass("series-navigation-active");
      $("#series-navigation-step3").addClass("series-navigation-active");
      $(".series-navigation-indicator").removeClass(
        "series-navigation-indicator2"
      );
      $(".series-navigation-indicator").addClass(
        "series-navigation-indicator3"
      );
      $("#series-navigation-step3").addClass("series-navigation-active");
      $("#series-navigation-step3").removeClass("series-navigation-not-yet");
    });

    $(".series-button-prev-step3").on("click", function (evt) {
      $("#series-step2").show();
      $("#series-step3").hide();
      $("#series-navigation-step2").addClass("series-navigation-active");
      $("#series-navigation-step3").removeClass("series-navigation-active");
      $("#series-navigation-step3").addClass("series-navigation-not-yet");
      $(".series-navigation-indicator").addClass(
        "series-navigation-indicator2"
      );
      $(".series-navigation-indicator").removeClass(
        "series-navigation-indicator3"
      );
    });

    $("#check-priority").on("click", function () {
      _this.design.order.priority = $(this).is(":checked") ? "low" : "normal";
      _this.design.order.refreshAmount(_this.theme);
      _this.design.order.refreshDeliveryDates();
      $("#cart-form [name=priority]").val(_this.design.order.priority);
    });

    $("#material-finish").change(function () {
      var finish = $(this).val();
      var slug = _this.design.material.slug;

      // HACK for polishing presented as a finish option
      var new_slug = slug;

      if (finish == "polish" && slug.indexOf("polished") == -1) {
        new_slug = "plastic_polished_" + slug.split("_")[0];
      }

      if (finish == "" && slug.indexOf("polished") != -1) {
        new_slug = slug.split("_")[2] + "_plastic";
      }

      if (finish == "polish") {
        finish = "";
      }

      if (slug.indexOf("60u") != -1 && new_slug.indexOf("60u") == -1) {
        new_slug += "_60u";
      }

      if (new_slug != slug) {
        _this.design.update_material(material_finish_data[new_slug]);
        $(".confirm-material_name").text(material_finish_data[new_slug].name);
      }

      _this.design.order.finish = finish;
      _this.design.order.refreshAmount(_this.theme);
      _this.design.order.refreshDeliveryDates(_this.theme);
      $("#cart-form [name=finish]").val(_this.design.order.finish);
    });

    $(".print_scale_preview .link").on("click", function () {
      _this.print_scale_preview($(this));
    });

    $.Topic("delivery-update-result").subscribe(function (data) {
      _this.update_delivery_dates(data);
    });
  },

  toggle_series_mode: function (enabled) {
    if (enabled) {
      $(".sidebar").hide();
      $("#designs_div").css({ width: "982px" });
      $("#content-right").css({ width: "562px" });
      $(".series-navigation").show();
      $("#series-navigation-step1").addClass("series-navigation-active");
      $("#series-navigation-step2").removeClass("series-navigation-active");
      $("#series-navigation-step3").removeClass("series-navigation-active");
      $("#series-step1").slideDown();
      $("#series-step2").hide();
      $("#series-step3").hide();

      var t = $("#order-details-box table").detach();

      $("#series-order-details-box").append(t);

      // Create the orientation viewer
      if (!viewerUI.series.orientation_viewer) {
        $.when(this.design.fetch_operation()).then(function () {
          $(".orientation-viewer").Sculpteo3DViewer({
            show_viewer_select: false,
            local: true,
            autorotate: false,
            src: viewerUI.design.model_url(),
          });
          viewerUI.series.orientation_viewer = $(
            ".orientation-viewer"
          ).Sculpteo3DViewer();
          viewerUI.adjust_contrast(viewerUI.design.material);
        });
      }

      var _this = this;
      var f = function (event, ui) {
        if (!viewerUI.series.orientation_viewer) {
          return;
        }

        var min, max, margin;
        var a, b, c, d;

        margin = 0.01;
        viewerUI.series.orientation_viewer.setCutColor(1.0, 0.0, 0.0, margin);

        var w, x, y, z;

        if (
          _this.design.series.orientation.w != _this.design.series.orientation.w
        ) {
          var positions = _this.design.series.positions;

          if (positions.length) {
            w = positions[0][3];
            x = positions[0][4];
            y = positions[0][5];
            z = positions[0][6];
          }
        } else {
          w = _this.design.series.orientation.w;
          x = _this.design.series.orientation.x;
          y = _this.design.series.orientation.y;
          z = _this.design.series.orientation.z;
        }

        var M = Sculpteo3DViewerTransform3D.quatMat3(w, x, y, z);

        a = -M[6];
        b = -M[7];
        c = -M[8];

        var maxd = Math.max(design.size.x, design.size.y, design.size.z);
        // * 1.2 is for default zoom factor, this way slider matches exactly cut height initially
        d =
          -(ui.value - 0.5) * maxd * 1.2 +
          a * viewerUI.design.center.x +
          b * viewerUI.design.center.y +
          c * viewerUI.design.center.z;
        viewerUI.series.orientation_viewer.setCutAxis(a, b, c, d);

        // Disable cuts at 1.0, as Flash viewer can't display colors at the same time
        if (ui.value == 1.0) {
          viewerUI.series.orientation_viewer.clrCutAxis();
        }

        // Force update to workaround Flash viewer bug
        viewerUI.series.orientation_viewer.setAutorotate(false);
      };

      $(".orientation-slider").slider({
        slide: f,
        change: f,
        min: 0.0,
        max: 1.0,
        step: 0.01,
        value: 1.0,
        orientation: "vertical",
      });
    } else {
      $(".sidebar").show();
      $("#designs_div").css({ width: "700px" });
      $("#content-right").css({ width: "280px" });
      $(".series-navigation").hide();
      $("#series-step1").hide();
      $("#series-step2").hide();
      $("#series-step3").hide();

      var t = $("#series-order-details-box table").detach();

      $("#order-details-box").prepend(t);
    }
  },

  update_delivery_dates: function (data) {
    $(".shipped_delta").html(data.shipped_delta);

    if (data.receipt_date) {
      $(".receipt_date-container").show();
    }

    $(".receipt_date").html(data.receipt_date);
    $(".receipt_timer").html(data.receipt_timer);

    if (data.receipt_date_iso) {
      var date_without_time = data.receipt_date_iso.split("T", 1);
      if (date_without_time != "n/a") {
        var parseDate = $.datepicker.parseDate(
          "yy-mm-dd",
          "" + date_without_time[0] + ""
        );
        var date = new Date(parseDate);
        var month = date.getMonth() + 1;

        $(".receipt_date_iso").html(
          date.getDate() + "/" + month + "/" + date.getFullYear()
        );
      }
    }
  },

  default_action: function () {
    var $form = $("#cart-form");

    $("[name=quantity]", $form).val(this.design.order.quantity);
    $("[name=uuid]", $form).val(
      this.design.model_uuid ? this.design.model_uuid : ""
    );
    $("[name=finish]", $form).val(this.design.order.finish);

    if (window.SculpteoAnalytics) {
      SculpteoAnalytics("addtocart", {
        uuid: $("[name=uuid]", $form).val(),
        quantity: $("[name=quantity]", $form).val(),
      });
    }

    $form.submit();
  },

  print_scale_preview: function ($el) {
    var scale = this.design.size.designerScale * this.design.size.userScale;
    var unit = this.design.size.unit;
    var material = this.design.material;
    var $this = $el.closest(".print_scale_preview");
    var url = $("iframe", $this).data("src");

    url += "?scale=" + scale + "&unit=" + unit;

    if (material) {
      url += "&design_product=" + material.id;
    }

    if (this.design.model_uuid) {
      url += "&editinfo=" + this.design.model_uuid;
    }

    $(".link", $this).removeClass("a").addClass("hidden");
    $(".loader", $this).show();
    Utils.setCookie("sculpteo-print-scale-preview", "inprogress", 0, "/");
    $("iframe", $this).attr("src", url);
    (function loop() {
      setTimeout(function () {
        if (Utils.getCookie("sculpteo-print-scale-preview") != null) {
          loop();
        } else {
          $(".link", $this).removeClass("hidden").addClass("a");
          $(".loader", $this).hide();
        }
      }, 1000);
    })();

    return false;
  },

  init_values: function () {},
};

var ConfigurableUI = function (design) {
  this.design = design;
};

ConfigurableUI.prototype = {
  preview_was_on_add_op: false,
  ready: function () {
    var _this = this;

    // $("#configure-preview").click(function() { _this.preview.apply(_this, arguments); });
    // $("#configure-hide-preview").click(function() { _this.hide_preview.apply(_this, arguments); });
    // tweak the sharing form
    $("#row-public input").attr("checked", true);
    $("#row-public").show();
    $("#row-printable span").removeClass("black"); // Always printable
    $("#row-printable input").attr("checked", true);
    $("#row-printable input").attr("disabled", true);
    $("#row-printable").hide();
    $("#row-customizable span").removeClass("black"); // Always customizable
    $("#row-customizable input").attr("checked", true);
    $("#row-customizable input").attr("disabled", true);
    $("#row-customizable").hide();

    /*
				// delete
				$(".remove-template").on("click", function(e) {
					e.preventDefault();
					jConfirm(gettext("Delete this customization template?") , "Confirmation", function (r) {
						if (r) {
							_this.hide_preview();
							TabItemUI.hide();
							_this.design.configuration_mode(false);
							_this.design.configuration_preview_mode(false);
							_this.set_configuration_state(false, false);
						}
					});
					return false;
				});
			preview
		*/
    $(".preview-template").on("click", function () {
      if (_this.design.is_configuration_preview_mode) {
        _this.hide_preview();
      } else {
        _this.preview();
      }
    });

    // Information
    $(".info-template").on("click", function () {
      var $create_tabitem = TabItemUI.from_el($("#create-button"));
      var $configure_wizard = $("#create-wizard-configure");

      TabItemUI.hide();
      $("#sidebar-tabitems-content").show();
      $("#sidebar-navigation").hide();
      $("#create-wizard").show();
      wizardUI.show_target("#create-wizard-configure", false);
      $(".wizard-navigation-back", $configure_wizard).hide();
      $(".configure-wizard-info-title").show();
      $(".configure-wizard-create-title").hide();
    });
  },

  set_configuration_state: function (active, preview) {
    $("#configuration-mode-chkbx").attr("checked", active);

    if (active) {
      $("#operations-container").addClass("configuration");
      $("#configure-button").show();
      $("#configuration-template").show();

      // Toggle create button name to "Add option"
      $(".create-name-customize").hide();
      $(".create-name-add-option").show();
    } else {
      $("#operations-container").removeClass("configuration");
      $("#configure-button").hide();
      $("#configuration-template").hide();

      // Toggle create button name to "Customize"
      $(".create-name-customize").show();
      $(".create-name-add-option").hide();

      // Reset the custom descriptions of all operations
      $(".operation-description").html("");
    }

    // Hide/show locks
    if (active && !preview) {
      $(".configuration-state-inactive")
        .removeClass("configuration-state-inactive")
        .addClass("configuration-state-active");
      $(".if-configuration-state-active:visible").slideDown();
      $(".if-configuration-state-inactive:visible").slideUp();
      $(".if-configuration-state-active:hidden").show();
      $(".if-configuration-state-inactive:hidden").hide();
    } else {
      $(".configuration-state-active")
        .removeClass("configuration-state-active")
        .addClass("configuration-state-inactive");
      $(".if-configuration-state-inactive:visible").slideDown();
      $(".if-configuration-state-active:visible").slideUp();
      $(".if-configuration-state-inactive:hidden").show();
      $(".if-configuration-state-active:hidden").hide();
    }

    // Hide "customize" button in preview mode
    if (active && preview) {
      $(".op-delete-short").hide();
      this.preview_was_on_add_op = $("#create-button")
        .closest("li")
        .hasClass("selected");
      $("#create-button").hide();

      if (this.preview_was_on_add_op) {
        $("#cursor-operation").hide();

        if (wizardUI.current == null) {
          $("#sidebar-tabitems-content").hide();
          $("#sidebar-navigation").show();
        }
      }
    } else {
      $("#create-button").show();

      if (this.preview_was_on_add_op) {
        $("#cursor-operation").show();

        if (wizardUI.current == null) {
          $("#sidebar-tabitems-content").show();
          $("#sidebar-navigation").hide();
        }

        this.preview_was_on_add_op = false;
      }
    }
  },

  preview: function (evt) {
    this.design.configuration_preview_mode(true);
    $("#configure-preview").hide();
    $("#configure-hide-preview").show();
    this.set_configuration_state(true, true);
    $(".preview-template").hide();
    $(".preview-disable").show();
  },

  hide_preview: function (evt) {
    this.design.configuration_preview_mode(false);
    $("#configure-preview").show();
    $("#configure-hide-preview").hide();
    this.set_configuration_state(true, false);
    $(".preview-template").show();
    $(".preview-disable").hide();
  },
};
